export const common = {
  // Navigation
  'nav.features': 'Özellikler',
  'nav.howItWorks': 'Nasıl çalışır',
  'nav.pricing': 'Fiyatlandırma',
  'nav.faq': 'SSS',
  'nav.aboutUs': 'Hakkımızda',
  'nav.getStarted': 'Başlayın',

  // About Us Section
  'aboutUs.badge': "Hakkımızda",
  'aboutUs.title': "IdeaVerdict neden var",
  'aboutUs.line1': "Herkesin bir fikri olabilir.",
  'aboutUs.line2': "Pek azı, kendi fikrinin tutmadığını kabul eder.",
  'aboutUs.paragraph1':
    "Fikirlerin çoğu, kurucuların cesareti olmadığı için başarısız olmaz. Kimse yeterince erken doğruyu söylemediği için başarısız olur. IdeaVerdict bu boşluğu kapatır — arkadaşlarınızın vermeyeceği sert okumayı biz veririz.",
  'aboutUs.belief1a': "Hype satmıyoruz.",
  'aboutUs.belief1b': "Pazar sinyali satıyoruz.",
  'aboutUs.belief2a': "Motivasyon satmıyoruz.",
  'aboutUs.belief2b': "Talep, rekabet ve uygulanabilirlik üzerine net bir okuma satıyoruz.",
  'aboutUs.mission1': "İşimiz fikrinizi iyi göstermek değil.",
  'aboutUs.mission2': "İşimiz, gerçekten iyi olup olmadığını söylemek.",
  'aboutUs.analysis':
    "IdeaVerdict fikirleri önemli olana göre puanlar — pazar yapısı, gerçek talep, rekabet, gereken sermaye, gelire ulaşma süresi, ölçeklenebilirlik. Duygu yok. İyimserlik yok. Sadece analiz.",
  'aboutUs.failure1': "İşletmelerin çoğu başarısız olur.",
  'aboutUs.failure2': "Arkasındaki insanlar yetersiz olduğu için değil —",
  'aboutUs.failure3': "kimse yeterince sert, yeterince erken itiraz etmediği için.",
  'aboutUs.clarity': "Biz itiraz etmek için varız.",
  'aboutUs.value1': "Doğrudan.",
  'aboutUs.value2': "Dürüst.",
  'aboutUs.value3': "Hızlı.",
  'aboutUs.confirm': "Fikrinizin özü varsa, arkasındayız.",
  'aboutUs.deny': "Yoksa, yüzünüze söyleriz.",
  'aboutUs.noApplause': "Alkış yok.",
  'aboutUs.noSugarcoating': "Şekerleme yok.",
  'aboutUs.noTheater': "Tiyatro yok.",
  'aboutUs.noHype': "Sadece karar.",
  // Hero Section
  'hero.badge': '60 saniyeden kısa sürede AI kararı',
  'hero.title1': 'Kontrol etmeden',
  'hero.title2': 'inşa etme.',
  'hero.subtitle': 'IdeaVerdict, fikrini şüpheci bir VC gibi sınar.',
  'hero.subtitleLine2': 'Saniyeler içinde dürüst karar — hype yok, dalkavukluk yok.',
  'hero.cta': 'Kararımı al',
  'hero.ctaSecondary': 'Nasıl çalışır',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'İstek başına kredi',
  'hero.stat2Value': '7+',
  'hero.stat2Label': 'Değerlendirme boyutu',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'Dürüst ve Gizli',

  // Features Section
  'features.title1': 'Gerçeği isteyen',
  'features.title2': 'kurucular için',
  'features.title3': 'tasarlandı',
  'features.bullet1.title': 'Saniyeler içinde dürüst karar',
  'features.bullet1.description':
    'Güçlü, Karışık veya Zayıf — gerekçesiyle birlikte. Alkış yok, şekerleme yok, tiyatro yok.',
  'features.bullet2.title': 'Önemli olana göre puanlanır',
  'features.bullet2.description':
    'Fikriniz gerçek talep, rekabet, gereken sermaye, gelire ulaşma süresi ve ölçeklenebilirlik üzerinden puanlanır — havaya göre değil.',
  'features.bullet3.title': 'Karardan inşaya',
  'features.bullet3.description':
    'Builder modu, onaylanan bir fikri geliştirici brifingine dönüştürür: kullanıcı akışları, temel özellikler, teknik notlar.',

  // How It Works
  'howItWorks.title': 'Nasıl çalışır',
  'howItWorks.subtitle': 'İş nişiniz hakkında netlik için dört adım.',
  'howItWorks.step1Title': 'Bir plan seçin',
  'howItWorks.step1Desc': 'Başlangıç, Pro veya Kurucu – incelemenizin derinliğine bağlı olarak.',
  'howItWorks.step2Title': 'AI\'ya sorun',
  'howItWorks.step2Desc': 'Niş hakkında sorularınızı sorun. Her istek 30 krediye mal olur.',
  'howItWorks.step3Title': 'Dürüst kararı alın',
  'howItWorks.step3Desc': 'AI derecelendirir: İyi, Orta veya Kötü. Şekerleme yok.',
  'howItWorks.step4Title': 'Bir karar verin',
  'howItWorks.step4Desc': "Artık ilerlemeye değer olup olmadığını biliyorsunuz.",

  // Pricing
  'pricing.title': 'Fiyatlandırma',
  'pricing.subtitle': 'İnceleme derinliğinize uygun planı seçin.',
  'pricing.monthly': 'Aylık',
  'pricing.yearly': 'Yıllık',
  'pricing.yearlyDiscount': 'Yıllık abonelik:',
  'pricing.yearlyDiscountValue': '-20% indirim',
  'pricing.perMonth': 'aylık',
  'pricing.selectPlan': 'Plan Seç',
  'pricing.mostPopular': 'En Popüler',
  'pricing.footer':
    'Tüm fiyatlar CHF cinsindendir. Krediler yalnızca başarılı AI yanıtları için kesilir.',

  
  // Pricing Features
  'pricing.feature1': 'Ücretsiz Sohbet (form yok)',
  'pricing.feature2': 'Piyasa mantığı ve dürüst puanlama',
  'pricing.feature3': 'Kalıcı sohbet geçmişi',
  'pricing.feature4': 'Çoklu paralel sohbet oturumları',
  'pricing.feature5': 'Tamamen çok dilli',
  'pricing.feature6': 'Krediye dayalı kullanım',
  'pricing.feature7': 'Aylık sıfırlama',
  'pricing.feature8': 'Pazar analizi',
  'pricing.feature9': 'Özet',
  'pricing.feature10': 'Güçlü yönler',
  'pricing.feature11': 'Zayıf yönler',
  'pricing.feature12': 'Fırsatlar',
  'pricing.feature13': 'Riskler',
  'pricing.feature14': 'Öneriler',
  'pricing.feature15': 'PDF İndir',
  'pricing.feature16': 'Geliştirici brifingi yok',
  'pricing.feature17': 'Kurucu modu: Geliştirici brifingleri',
  'pricing.feature18': 'Yapılandırılmış özet',

  // Starter Plan
  'pricing.starter.name': 'Başlangıç',
  'pricing.starter.price': '39.90',
  'pricing.starter.description': 'AI niş sohbet robotuna erişim',
  'pricing.starter.credits': 'Ayda 2.500 Kredi',
  'pricing.starter.feature1': 'Niş fikri oluştur',
  'pricing.starter.feature2': 'Nişi iyileştir',
  'pricing.starter.feature3': 'Pazar gerçeklik kontrolü',
  'pricing.starter.feature4': 'Rekabet değerlendirmesi',
  'pricing.starter.feature5': 'Zaman değerlendirmesi',
  'pricing.starter.feature6': 'Dürüst karar',
  'pricing.starter.feature7': 'Özel oturumlar',
  'pricing.starter.feature8': 'Geçmiş ve dışa aktarma',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.price': '59.90',
  'pricing.pro.description': 'AI niş sohbet robotuna erişim',
  'pricing.pro.credits': 'Ayda 5.000 Kredi',
  'pricing.pro.feature1': 'Tüm Başlangıç özellikleri',
  'pricing.pro.feature2': 'Yoğun inceleme için daha fazla kredi',
  'pricing.pro.feature3': 'İyileştirme önerileri',
  'pricing.pro.feature4': 'Alternatif nişler',
  'pricing.pro.feature5': 'Detaylı pazar analizi',
  'pricing.pro.feature6': 'Öncelikli destek',
  'pricing.pro.feature7': 'Gelişmiş filtreler',
  'pricing.pro.feature8': 'Oturum favorileri',

  // Builder Plan
  'pricing.builder.name': "Builder",
  'pricing.builder.price': '199',
  'pricing.builder.description': "Tüm özellikler + Builder modu",
  'pricing.builder.credits': "Aylık 10.000 Kredi",
  'pricing.builder.feature1': 'Tüm Pro özellikleri',
  'pricing.builder.feature2': 'Sınırsız AI isteği',
  'pricing.builder.feature3': 'Kurucu modu: Geliştirici brifingleri',
  'pricing.builder.feature4': 'Yapılandırılmış proje genel bakışı',
  'pricing.builder.feature5': 'Kullanıcı akışları ve temel özellikler',
  'pricing.builder.feature6': 'Teknik notlar',
  'pricing.builder.feature7': 'Hedef dışı tanımla',
  'pricing.builder.feature8': 'Adil kullanım hız sınırı',
  'pricing.builder.limitNote': 'Adil kullanım sınırı',
  'pricing.monthlyReset': 'Aylık sıfırlama',

  // Modal
  'pricing.modal.selected': 'seçildi',
  'pricing.modal.comingSoon':
    'Kayıt ve ödeme işlemi yakında kullanıma sunulacaktır.',
  'pricing.modal.patience':
    'Size güvenli ve sorunsuz bir deneyim sunmak için çalışıyoruz. Lütfen sabırlı olun.',
  'pricing.modal.understood': 'Anlaşıldı',

  // FAQ
  'faq.title': 'SSS',
  'faq.subtitle': 'Dürüst ve eleştirel bir şekilde cevaplandı.',
  'faq.q1': "IdeaVerdict gerçekten ne yapar?",
  'faq.a1': "İş fikrinizi sonucu belirleyen şeylere göre puanlar — gerçek talep, rekabet, gereken sermaye, pazara çıkış süresi ve ölçeklenebilirlik.\nFikir tutuyorsa, nasıl keskinleştireceğinizi gösteririz.\nTutmuyorsa, bunu da söyleriz.",
  'faq.q2': "Fikir de üretiyor musunuz?",
  'faq.a2': "Evet — ama şapkadan rastgele öneriler değil.\nFikirler bu haftanın trendlerinden değil, gerçek pazar boşluklarından gelir.",
  'faq.q3': "Mevcut iş modellerini geliştiriyor musunuz?",
  'faq.a3': "Evet, geliştirilecek bir şey varsa.\nKırık fikirleri cilalamayız — zaten zemini olanları güçlendiririz.",
  'faq.q4': "Diğer yapay zeka araçlarından farkınız ne?",
  'faq.a4': "Yapay zeka araçlarının çoğu fikrinizin harika olduğunu söyler.\nBiz gerçekten harika olup olmadığını söyleriz.\nFark: coşku yerine gerçekçilik.",
  'faq.q5': "Bu başarıyı garanti eder mi?",
  'faq.a5': "Hayır.\nKötü bahislerden kaçınmanıza yardım ederiz — risk yok olmaz, ama gözünüz açık girersiniz.",
  'faq.q6': "IdeaVerdict kimin için?",
  'faq.a6': "Lansman öncesi kurucular için.\nHafta sonu yan projesi öncesi geliştiriciler için.\nBir sonraki bahis öncesi operatörler için.\nİmza öncesi yatırımcılar için.\n\nTaahhütten önce netlik isteyen herkes için.",
  'faq.q7': "Sadece onay istiyorsam ne olur?",
  'faq.a7': "O zaman IdeaVerdict yanlış araç.\nBiz güvence değil, dürüst okuma veririz.",
  'faq.q8': "Analiz aslında ne kadar dürüst?",
  'faq.a8': "Verinin izin verdiği kadar dürüst.\nDuyguları korumak için zayıf bir kararı yumuşatmayız.",
  'faq.q9': "Bu gerçek pazar araştırmasının yerini tutar mı?",
  'faq.a9': "Hayır.\nYatırım öncesi hızlı bir stratejik kontroldür — 50 sayfalık pazar çalışması değil.",
  'faq.q10': "Neden bu kadar doğrudan?",
  'faq.a10': "Çünkü yanlış şeyi inşa etmek aylara mal olur.\nDürüst bir karar dakikalara mal olur.\n\nBiz dakikaları seçiyoruz.",
  // Footer
  'footer.description':
    'IdeaVerdict seni iyi hissettirmek için değil. Doğru karar vermene yardım etmek için var.',
  'footer.product': 'Ürün',
  'footer.aiAssistant': 'AI Asistanı',
  'footer.howItWorks': 'Nasıl çalışır',
  'footer.pricing': 'Fiyatlandırma',
  'footer.faq': 'SSS',
  'footer.legal': 'Yasal',
  'footer.privacy': 'Gizlilik',
  'footer.terms': 'Şartlar',
  'footer.imprint': 'Künye',
  'footer.support': 'Destek',
  'footer.contact': 'İletişim',
  'footer.documentation': 'Dokümantasyon',
  'footer.copyright': '© 2026 IdeaVerdict. Tüm hakları saklıdır.',

  // AI Assistant
  'aiAssistant.title': 'AI Niş Asistanı',
  'aiAssistant.subtitle': 'Nişler hakkında soru sorun',
  'aiAssistant.welcomeMessage':
    'Merhaba! Fikrinizi açıklayın veya bana bir niş hakkında soru sorun. Size net ve dürüst bir değerlendirme yapacağım.',
  'aiAssistant.demoResponse':
    'Bu bir demo. Gerçek AI değerlendirmeleri almak için lütfen kaydolun ve bir plan seçin.',
  'aiAssistant.placeholder': 'Fikrinizi açıklayın...',

  // Header & Sidebar
  'dashboard.header.title': 'Panel',
  'dashboard.header.aiAssistant': 'AI Asistanınız',
  'header.logout': 'Çıkış Yap',
  'dashboard.sidebar.overview': 'Genel Bakış',
  'dashboard.sidebar.aiChat': 'AI Asistanı',
  'dashboard.sidebar.newAnalysis': 'AI Asistanı',
  'dashboard.sidebar.history': 'Geçmiş',
  'dashboard.sidebar.credits': 'Krediler',
  'dashboard.sidebar.settings': 'Ayarlar',

  // Dashboard Overview
  'dashboard.overview.welcome': 'Tekrar hoş geldiniz, {{name}}',
  'dashboard.overview.subtitle':
    'İşte aktivitelerinizin hızlı bir genel bakışı',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'Kalan kredi',
  'dashboard.stats.totalAnalyses': 'Toplam analiz',
  'dashboard.stats.goodRatings': 'Olumlu değerlendirmeler',
  'dashboard.stats.nextReset': 'Sonraki sıfırlama',
  'dashboard.stats.days': 'gün',

  // Quick Actions
  'dashboard.quickActions.title': 'Hızlı işlemler',
  'dashboard.quickActions.checkNewIdea': 'Bir fikri kontrol et',
  'dashboard.quickActions.checkNewIdeaDesc':
    'Mevcut bir iş fikrini analiz et',
  'dashboard.quickActions.generateIdea': 'Bir fikir oluştur',
  'dashboard.quickActions.generateIdeaDesc':
    'Yeni bir karlı niş bul',
  'dashboard.quickActions.builderBriefing': 'Kurucu brifingi',
  'dashboard.quickActions.builderBriefingDesc':
    'Bir fikri geliştiriciye hazır brifinge dönüştür',
  'dashboard.quickActions.premiumOnly': 'Sadece Kurucu',

  // Chat Header
  'chat.title': 'AI Niş Asistanı',
  'chat.subtitle':
    'Nişler hakkında sorular sorun. Eleştirel ve dürüst bir şekilde değerlendiriyorum.',
  'chat.creditsLabel': 'Krediler',

  // Chat Welcome
  'chat.welcomeTitle': 'AI Niş Asistanına Hoş Geldiniz',
  'chat.welcomeDesc':
    'Fikrinizi açıklayın veya bir niş hakkında soru sorun. Dürüstçe değerlendireceğim: İyi, Orta veya Kötü.',
  'chat.aiWelcome':
    'Merhaba! Fikrinizi açıklayın veya bana bir niş hakkında soru sorun. Size net ve dürüst bir değerlendirme yapacağım.',

  // Chat Suggestions
  'chat.suggestion1': 'Freelancerlar için fatura yönetimi SaaS aracı yapmak istiyorum. Bu iyi bir niş mi?',
  'chat.suggestion2': 'Kodlama bilgisi olmadan $500 ile başlayabileceğim düşük rekabetli bir online iş bul.',
  'chat.suggestion3': 'Bunu değerlendir: Diyet kısıtlamaları olan meşgul ebeveynler için AI destekli yemek planlama uygulaması.',
  'chat.suggestion4': 'Etsy\'de küçük işletme sahipleri için dijital şablonlar satmak istiyorum. Bu nişi dürüstçe analiz et.',

  // Chat Actions
  'chat.newConversation': 'Yeni konuşma',
  'chat.today': 'Bugün',
  'chat.yesterday': 'Dün',
  'chat.thisWeek': 'Bu hafta',
  'chat.thisMonth': 'Bu ay',
  'chat.older': 'Daha eski',
  'chat.messages': 'mesaj',
  'chat.renameConversation': 'Yeniden adlandır',
  'chat.deleteConversation': 'Sil',
  'chat.cancel': 'İptal',
  'chat.rename': 'Yeniden adlandır',
  'chat.delete': 'Sil',
  'chat.favorite': 'Favorilere ekle',
  'chat.unfavorite': 'Favorilerden çıkar',
  'chat.searchSessions': 'Konuşmaları ara...',
  'chat.noResults': 'Sonuç bulunamadı',
  'chat.noSessions': 'Henüz konuşma yok',
  'chat.enterNewName': 'Yeni ad girin...',
  'chat.deleteConfirmMessage':
    'Bu konuşmayı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'Sorunuzu yazın… (30 krediye mal olur)',
  'chat.send': 'Gönder',
  'chat.voice': 'Konuş',
  'chat.listeningPlaceholder': 'Dinliyorum... Şimdi konuşun.',
  'chat.stopListening': 'Dinlemeyi durdur',
  'chat.recording': 'Kayıt yapılıyor...',
  'chat.speechNotSupported': 'Tarayıcınız ses tanımayı desteklemiyor.',
  'chat.microphonePermissionDenied': 'Mikrofon erişimi reddedildi. Lütfen tarayıcı ayarlarında izin verin.',
  'chat.errorNotEnoughCredits':
    'Yeterli kredi yok. Lütfen planınızı yükseltin veya bir sonraki sıfırlamayı bekleyin.',
  'chat.errorAiFailed': 'AI yanıtı başarısız oldu. Hiçbir kredi kesilmedi.',
  'chat.errorRateLimit': 'Çok fazla istek. Lütfen bir dakika bekleyin.',

  // Ratings
  'rating.good': 'İyi',
  'rating.medium': 'Orta',
  'rating.bad': 'Kötü',

  // Auth Page
  'auth.branding.headline1': 'Her fikir iyi değildir.',
  'auth.branding.headline2': 'Size dürüstçe söyleriz.',
  'auth.branding.subtitle':
    'İş nişleri için bir karar AI. Net. Eleştirel. Şekerleme yok.',
  'auth.benefits.privacy.title': '%100 Gizli',
  'auth.benefits.privacy.desc':
    'Fikirleriniz tamamen gizli ve güvende kalır.',
  'auth.benefits.honest.title': 'Dürüst AI',
  'auth.benefits.honest.desc':
    'Şekerleme yok – sadece net, eleştirel geri bildirim.',
  'auth.benefits.fast.title': 'Hızlı Sonuçlar',
  'auth.benefits.fast.desc': 'Nişiniz hakkında dakikalar içinde netlik kazanın.',
  'auth.trust.users': 'Aktif Kullanıcı',
  'auth.trust.ideas': 'Fikir Analiz Edildi',
  'auth.trust.rating': 'Kullanıcı Puanı',
  'auth.login.title': 'Giriş Yap',
  'auth.login.headline': 'Tekrar hoş geldiniz',
  'auth.login.subtitle': 'Yolculuğunuza devam etmek için giriş yapın.',
  'auth.login.forgotPassword': 'Şifremi unuttum?',
  'auth.login.submit': 'Giriş Yap',
  'auth.login.noAccount': 'Hesabınız yok mu?',
  'auth.login.signUp': 'Kaydolun',
  'auth.register.title': 'Kaydol',
  'auth.register.headline': 'Hesabınızı oluşturun',
  'auth.register.subtitle':
    'İş fikirlerinizi bugün analiz etmeye başlayın.',
  'auth.register.submit': 'Hesap Oluştur',
  'auth.register.hasAccount': 'Zaten hesabınız var mı?',
  'auth.register.signIn': 'Giriş yapın',
  'auth.fields.name': 'Ad Soyad',
  'auth.fields.email': 'E-posta Adresi',
  'auth.fields.password': 'Şifre',
  'auth.fields.confirmPassword': 'Şifreyi Onayla',
  'auth.fields.selectPlan': 'Planınızı seçin',
  'auth.fields.testCode': 'Ücretsiz denemek için giriş yapın',
  'auth.placeholders.name': 'Adınızı girin',
  'auth.placeholders.email': 'E-postanızı girin',
  'auth.placeholders.password': 'Şifrenizi girin',
  'auth.placeholders.confirmPassword': 'Şifrenizi onaylayın',
  'auth.placeholders.testCode': 'Test kodunu girin',
  'auth.terms.accept': 'Kabul ediyorum',
  'auth.terms.terms': 'Kullanım Şartları',
  'auth.privacy.accept': 'Kabul ediyorum',
  'auth.privacy.policy': 'Gizlilik Politikası',
  'auth.errors.nameRequired': 'Ad gereklidir',
  'auth.errors.emailRequired': 'E-posta gereklidir',
  'auth.errors.emailInvalid': 'Lütfen geçerli bir e-posta girin',
  'auth.errors.passwordRequired': 'Şifre gereklidir',
  'auth.errors.passwordLength': 'Şifre en az 8 karakter olmalıdır',
  'auth.errors.passwordMismatch': 'Şifreler eşleşmiyor',
  'auth.errors.invalidCode': 'Geçersiz veya süresi dolmuş kod',
  'auth.errors.registrationCodeOnly': 'Bu kod sadece kayıt içindir',
  'auth.errors.verificationFailed': 'Kod doğrulanırken hata oluştu. Lütfen tekrar deneyin.',
  'auth.loading': 'Lütfen bekleyin...',
  'auth.or': 'veya devam et',
  'auth.social.google': 'Google ile devam et',
  'auth.social.apple': 'Apple ile devam et',
  'auth.actions.verify': 'Doğrula',
  'auth.testCode.activated': 'Test kodu aktifleştirildi!',
  'auth.testCode.days': 'gün',
  'auth.testCode.months': 'ay',
  'auth.testCode.freeAccess': 'ücretsiz erişim',
  'auth.testCode.credits': 'kredi',

  // Email Verification
  'auth.verification.title': 'E-postayı Doğrula',
  'auth.verification.headline': 'Gelen kutunuzu kontrol edin',
  'auth.verification.subtitle': 'Bir doğrulama kodu gönderdik:',
  'auth.verification.codeLabel': 'Doğrulama Kodu',
  'auth.verification.codePlaceholder': '6 haneli kodu girin',
  'auth.verification.submit': 'E-postayı Doğrula',
  'auth.verification.resend': 'Kodu tekrar gönder',
  'auth.verification.resendIn': 'Tekrar gönder',
  'auth.verification.seconds': 'saniye',
  'auth.verification.success': 'E-posta başarıyla doğrulandı!',
  'auth.verification.error': 'Geçersiz kod. Lütfen tekrar deneyin.',
  'auth.verification.expired': 'Kodun süresi doldu. Lütfen yeni bir tane isteyin.',
  'auth.verification.sent': 'Yeni kod gönderildi!',
  'auth.verification.checkSpam':
    "Almadınız mı? Spam klasörünüzü kontrol edin.",

  // Forgot Password
  'auth.forgot.title': 'Şifremi Unuttum',
  'auth.forgot.headline': 'Şifrenizi sıfırlayın',
  'auth.forgot.subtitle':
    "E-posta adresinizi girin, size bir sıfırlama bağlantısı gönderelim.",
  'auth.forgot.submit': 'Sıfırlama Bağlantısı Gönder',
  'auth.forgot.backToLogin': 'Girişe dön',
  'auth.forgot.success': 'E-posta gönderildi!',
  'auth.forgot.successMessage':
    "Şifrenizi sıfırlamak için talimatlar içeren bir e-posta gönderdik.",
  'auth.forgot.checkInbox': 'Gelen kutunuzu kontrol edin',

  // Reset Password
  'auth.reset.title': 'Yeni Şifre',
  'auth.reset.headline': 'Yeni şifre belirleyin',
  'auth.reset.subtitle': 'Yeni şifrenizi girin.',
  'auth.reset.newPassword': 'Yeni Şifre',
  'auth.reset.confirmNewPassword': 'Yeni Şifreyi Onayla',
  'auth.reset.submit': 'Şifreyi Değiştir',
  'auth.reset.success': 'Şifre başarıyla değiştirildi!',
  'auth.reset.successMessage':
    'Artık yeni şifrenizle giriş yapabilirsiniz.',
  'auth.reset.loginNow': 'Şimdi giriş yapın',

  // Legal Pages
  'legal.backToAuth': 'Girişe dön',
  'legal.allRightsReserved': 'Tüm hakları saklıdır.',

  // Terms Page
  'legal.terms.title': 'Kullanım Şartları ve Koşulları',
  'legal.terms.lastUpdated': 'Son güncelleme',
  'legal.terms.section1.title': '1. Kapsam',
  'legal.terms.section1.content':
    'Bu Kullanım Şartları ve Koşulları, IdeaVerdict (bundan sonra "Sağlayıcı" olarak anılacaktır) ile kullanıcı (bundan sonra "Müşteri" olarak anılacaktır) arasında AI destekli niş analiz platformunun kullanımına ilişkin tüm sözleşmeler için geçerlidir.',
  'legal.terms.section2.title': '2. Hizmet Açıklaması',
  'legal.terms.section2.content':
    'Sağlayıcı, iş fikirlerini ve nişlerini analiz eden ve değerlendiren AI tabanlı bir platform sunar. Hizmetler şunları içerir:',
  'legal.terms.section2.item1': 'İş fikirlerinin AI destekli analizi',
  'legal.terms.section2.item2': 'Pazar potansiyeli ve rekabet değerlendirmesi',
  'legal.terms.section2.item3': 'Niş önerileri oluşturma',
  'legal.terms.section2.item4': 'Geliştirici brifingleri oluşturma (Kurucu paketi)',
  'legal.terms.section3.title': '3. Sözleşme Kurulumu ve Kayıt',
  'legal.terms.section3.content':
    'Sözleşme, platforma kayıt ve bir paket seçimi ile kurulur. Müşteri şunları onaylar:',
  'legal.terms.section3.item1': 'Reşit ve tam ehliyetli olmak',
  'legal.terms.section3.item2': 'Kayıt sırasında doğru bilgileri vermek',
  'legal.terms.section3.item3': 'Erişim bilgilerini güvenli bir şekilde saklamak',
  'legal.terms.section4.title': '4. Krediler ve Faturalama',
  'legal.terms.section4.content':
    'AI özelliklerinin kullanımı bir kredi sistemine dayanır. Her AI sorgusu 30 krediye mal olur. Krediler yalnızca başarılı yanıt durumunda kesilir. Kullanılmayan krediler fatura dönemi sonunda dolar ve iade edilmez.',
  'legal.terms.section5.title': '5. Sorumluluk Reddi',
  'legal.terms.section5.content':
    'AI değerlendirmeleri yalnızca karar yardımcıları olarak hizmet eder ve iş başarısını garanti etmez. Sağlayıcı, AI analizlerine dayanarak alınan kararlardan sorumlu değildir. Kasten ve ağır ihmalden kaynaklanan sorumluluk etkilenmez.',
  'legal.terms.section6.title': '6. Veri Koruma ve Gizlilik',
  'legal.terms.section6.content':
    'Gönderilen tüm iş fikirleri gizli tutulur ve üçüncü taraflarla paylaşılmaz. Kişisel verilerin işlenmesi, Gizlilik Politikamıza ve geçerli veri koruma yasalarına uygun olarak gerçekleştirilir.',
  'legal.terms.section7.title': '7. Fesih',
  'legal.terms.section7.content':
    'Müşteri, aboneliğini istediği zaman cari fatura döneminin sonunda iptal edebilir. Bu Şartların ihlali durumunda, Sağlayıcı platforma erişimi engelleme hakkını saklı tutar.',
  'legal.terms.section8.title': '8. Son Hükümler',
  'legal.terms.section8.content':
    'İsviçre kanunu uygulanır. Yetki yeri Zürih, İsviçre\'dir. Bu Şartların bireysel hükümleri geçersiz olursa, kalan hükümlerin geçerliliği etkilenmez.',
  'legal.terms.contact.title': 'Şartlar hakkında sorularınız mı var?',
  'legal.terms.contact.content':
    'Bu Kullanım Şartları hakkında sorularınız varsa, lütfen bizimle iletişime geçin:',

  // Privacy Page
  'legal.privacy.title': 'Gizlilik Politikası',
  'legal.privacy.section1.title': '1. Veri Sorumlusu',
  'legal.privacy.section1.content':
    'Bu web sitesinin veri sorumlusu IdeaVerdict, Zürih, İsviçre\'dir. Kişisel verilerinizin korunmasını çok ciddiye alıyoruz ve kişisel verilerinizi gizli ve yasal veri koruma düzenlemelerine uygun olarak işliyoruz.',
  'legal.privacy.section2.title': '2. Toplanan Veriler',
  'legal.privacy.section2.content':
    'Aşağıdaki kişisel verileri topluyor ve işliyoruz:',
  'legal.privacy.section2.item1':
    'Kayıt verileri: Ad, e-posta adresi, şifre (şifrelenmiş)',
  'legal.privacy.section2.item2':
    'Kullanım verileri: IP adresi, tarayıcı türü, erişim saatleri',
  'legal.privacy.section2.item3':
    'İş fikirleri ve niş sorguları (anonim olarak saklanır)',
  'legal.privacy.section2.item4':
    'Ödeme bilgileri (güvenli üçüncü taraf sağlayıcılar aracılığıyla)',
  'legal.privacy.section3.title': '3. Veri İşleme Amacı',
  'legal.privacy.section3.content':
    'Verileriniz aşağıdaki amaçlar için kullanılır:',
  'legal.privacy.section3.item1':
    'AI hizmetlerimizin sağlanması ve iyileştirilmesi',
  'legal.privacy.section3.item2':
    'Hesap yönetimi ve kimlik doğrulama',
  'legal.privacy.section3.item3':
    'Faturalama ve ödeme işleme',
  'legal.privacy.section4.title': '4. Veri Güvenliği',
  'legal.privacy.section4.content':
    'Verilerinizi manipülasyona, kayba, tahribata veya yetkisiz erişime karşı korumak için teknik ve organizasyonel güvenlik önlemleri uyguluyoruz. Tüm veri aktarımları SSL/TLS ile şifrelenir.',
  'legal.privacy.section5.title': '5. İş Fikirlerinizin Gizliliği',
  'legal.privacy.section5.content':
    'Gönderdiğiniz iş fikirleri ve niş sorguları kesinlikle gizli tutulur. Üçüncü taraflarla paylaşılmaz, eğitim amaçlı kullanılmaz ve talep üzerine tamamen silinebilir. Fikirleriniz size aittir.',
  'legal.privacy.section6.title': '6. Haklarınız',
  'legal.privacy.section6.content':
    'Kişisel verilerinizle ilgili olarak aşağıdaki haklara sahipsiniz:',
  'legal.privacy.section6.item1': 'Saklanan verilere erişim hakkı',
  'legal.privacy.section6.item2': 'Yanlış verilerin düzeltilmesi hakkı',
  'legal.privacy.section6.item3': 'Verilerinizin silinmesi hakkı',
  'legal.privacy.section6.item4': 'Veri taşınabilirliği hakkı',
  'legal.privacy.section7.title': '7. Çerezler',
  'legal.privacy.section7.content':
    'Web sitemiz yalnızca kimlik doğrulama ve oturum yönetimi için teknik olarak gerekli çerezleri kullanır. Açık onayınız olmadan izleme çerezleri veya üçüncü taraf analiz araçları kullanmıyoruz.',
  'legal.privacy.section8.title': '8. Bu Gizlilik Politikasında Değişiklikler',
  'legal.privacy.section8.content':
    'Bu gizlilik politikasını değişen yasal gereksinimlere veya hizmetteki değişikliklere uyum sağlamak için uyarlama hakkını saklı tutarız. Güncel sürüm her zaman bu sayfada bulunabilir.',
  'legal.privacy.contact.title': 'Gizlilik hakkında sorularınız mı var?',
  'legal.privacy.contact.content':
    'Kişisel verilerinizin işlenmesi hakkında sorularınız varsa, lütfen bizimle iletişime geçin:',

  'auth.passwordStrength.label': 'Şifre gücü',
  'auth.passwordStrength.weak': 'Zayıf',
  'auth.passwordStrength.medium': 'Orta',
  'auth.passwordStrength.strong': 'Güçlü',
  'auth.passwordStrength.veryStrong': 'Çok güçlü',
  'auth.passwordStrength.minLength': 'Min. 8 karakter',
  'auth.passwordStrength.uppercase': 'Büyük harf',
  'auth.passwordStrength.number': 'Rakam',
  'auth.passwordStrength.special': 'Özel karakter',

  trial: {
    subtitle: 'Ücretsiz Deneme',
    upgrade: 'Şimdi Yükselt',
    creditsRemaining: 'kredi kaldı',
    inputHint: 'Deneme sürümü - Konuşma geçmişi mevcut değil',
    banner: {
      title: '7 Günlük Deneme Aktif',
      remaining: '{{days}} gün kaldı',
      credits: 'kredi mevcut',
      upgradeNow: 'Şimdi Yükselt',
    },
    welcome: {
      title: 'Ücretsiz Denemeye Hoş Geldiniz!',
      desc: 'AI asistanımızı 7 gün boyunca 100 kredi ile ücretsiz test edin. Sorular sorun ve olanakları keşfedin!',
    },
    info: {
      title: 'Deneme Sınırlamaları',
      credits: '7 gün için 100 kredi',
      noHistory: 'Konuşma geçmişi yok',
      noSettings: 'Sınırlı özellikler',
      upgrade: 'Tüm özellikler için yükseltin',
    },
  },

  // ─── Settings Page ────────────────────────────────────────────────────────────
  'settings.title': 'Ayarlar',
  'settings.subtitle': 'Hesabınızı ve tercihlerinizi yönetin',
  'settings.backToOverview': 'Genel bakışa dön',
  'settings.subscriptionLink': 'Abonelik ve Faturalama',
  'settings.saved': 'Değişiklikler başarıyla kaydedildi',
  'settings.changesSaved': 'Değişiklikler kaydedildi',
  'settings.saveChanges': 'Değişiklikleri kaydet',
  'settings.dataExported': 'Veriler başarıyla dışa aktarıldı',

  // Tabs
  'settings.tabs.profile': 'Profil',
  'settings.tabs.preferences': 'Tercihler',
  'settings.tabs.notifications': 'Bildirimler',
  'settings.tabs.account': 'Hesap ve Plan',

  // Profile
  'settings.profile.changePhoto': 'Fotoğrafı değiştir',
  'settings.profile.photoHint': 'JPG, PNG veya GIF (max. 2MB)',
  'settings.profile.uploading': 'Yükleniyor...',
  'settings.profile.photoUpdated': 'Profil fotoğrafı güncellendi!',
  'settings.profile.name': 'İsim',
  'settings.profile.email': 'E-posta',
  'settings.profile.phone': 'Telefon',
  'settings.profile.changePassword': 'Şifreyi değiştir',
  'settings.profile.currentPassword': 'Mevcut şifre',
  'settings.profile.newPassword': 'Yeni şifre',
  'settings.profile.confirmPassword': 'Şifreyi onayla',

  // Preferences
  'settings.preferences.language': 'Dil',
  'settings.preferences.chooseLanguage': 'Dil seçin',
  'settings.preferences.timezone': 'Saat dilimi',
  'settings.preferences.currency': 'Para birimi',

  // Notifications
  'settings.notifications.emailTitle': 'E-posta Bildirimleri',
  'settings.notifications.email.analysis': 'Analiz tamamlandı',
  'settings.notifications.email.analysisDesc': 'Analiziniz hazır olduğunda e-posta alın',
  'settings.notifications.email.credits': 'Kredi güncellemeleri',
  'settings.notifications.email.creditsDesc': 'Krediler ve sıfırlamalar hakkında bildirimler',
  'settings.notifications.email.billing': 'Faturalar ve Ödemeler',
  'settings.notifications.email.billingDesc': 'Faturalar ve plan değişiklikleri hakkında bildirimler',
  'settings.notifications.email.newsletter': 'Bülten',
  'settings.notifications.email.newsletterDesc': 'İpuçları, güncellemeler ve yeni özellikler',
  'settings.notifications.pushTitle': 'Bildirimler',
  'settings.notifications.push.analysis': 'Analiz tamamlandı',
  'settings.notifications.push.analysisDesc': 'Analiz hazır olduğunda tarayıcı bildirimi',
  'settings.notifications.push.credits': 'Kredi uyarıları',
  'settings.notifications.push.creditsDesc': 'Kredi bakiyesi düşük olduğunda uyarı',

  // Account
  'settings.account.currentSubscription': 'Mevcut Abonelik',
  'settings.account.plan': 'Plan',
  'settings.account.price': 'Fiyat',
  'settings.account.nextBilling': 'Sonraki faturalama',
  'settings.account.manageSubscription': 'Aboneliği ve ödemeleri yönet',
  'settings.account.dataPrivacy': 'Veri ve Gizlilik',
  'settings.account.exportData': 'Verileri dışa aktar',
  'settings.account.deleteAccount': 'Hesabı sil',

  // Delete Modal
  'settings.deleteModal.title': 'Hesap silinsin mi?',
  'settings.deleteModal.subtitle': 'Tüm veriler kalıcı olarak silinecektir.',
  'settings.deleteModal.warning1': 'Tüm analizler ve veriler silinecek',
  'settings.deleteModal.warning2': 'Aktif abonelik derhal iptal edilecek',
  'settings.deleteModal.warning3': 'İade mümkün değil',
  'settings.deleteModal.confirmLabel': 'Onaylamak için "{{word}}" yazın *',
  'settings.deleteModal.cancel': 'İptal',
  'settings.deleteModal.confirm': 'Hesabı sil',

  // ─── Subscription & Billing ─────────────────────────────
  'sub.backToOverview': 'Genel bakışa dön',
  'sub.settings': 'Ayarlar',
  'sub.title': 'Abonelik ve Faturalama',
  'sub.subtitle': 'Aboneliğinizi, ödeme yöntemlerinizi ve faturalarınızı yönetin',
  'sub.tab.overview': 'Genel Bakış',
  'sub.tab.payment': 'Ödeme Yöntemleri',
  'sub.tab.billing': 'Fatura Adresi',
  'sub.tab.history': 'Ödeme Geçmişi',
  'sub.memberSince': 'Üyelik tarihi',
  'sub.perMonth': 'aylık',
  'sub.baseCHF': '(CHF {{amount}} taban)',
  'sub.nextBilling': 'Sonraki faturalama',
  'sub.creditsUsed': 'Kullanılan kredi',
  'sub.paymentMethod': 'Ödeme yöntemi',
  'sub.creditUsage': 'Kredi kullanımı',
  'sub.changePlan': 'Planı değiştir',
  'sub.reactivate': 'Yeniden aktifleştir',
  'sub.cancelSub': 'Aboneliği iptal et',
  'sub.manageCards': 'Kartları yönet',
  'sub.downloadInvoices': 'Faturaları indir',
  'sub.invoicesAvailable': 'PDF olarak {{count}} fatura mevcut',
  'sub.accountSettings': 'Hesap Ayarları',
  'sub.profileNotifications': 'Profil, bildirimler ve daha fazlası',
  // Prices in EUR info
  'sub.eurInfo': 'Fiyatlar gösteriliyor',
  'sub.eurLabel': 'Euro',
  'sub.eurRate': 'Kur:',
  'sub.currentRate': 'Güncel kur',
  // Payment Methods
  'sub.savedCards': 'Kayıtlı Kartlar',
  'sub.newCard': 'Yeni Kart',
  'sub.default': 'Varsayılan',
  'sub.setDefault': 'Varsayılan yap',
  'sub.validUntil': 'Geçerlilik tarihi',
  'sub.noCards': 'Kayıtlı kart yok',
  'sub.addFirstCard': 'İlk kartı ekle',
  'sub.securePayments': 'Güvenli Ödemeler',
  'sub.securePaymentsDesc': 'Tüm ödeme verileri şifrelenmiş olarak iletilir ve ödeme sağlayıcımızla güvenli bir şekilde saklanır. Tam kart numaralarını saklamıyoruz.',
  // Billing Address
  'sub.billingAddress': 'Fatura Adresi',
  'sub.edit': 'Düzenle',
  'sub.name': 'İsim',
  'sub.streetAddress': 'Cadde ve No',
  'sub.zip': 'Posta Kodu',
  'sub.city': 'Şehir',
  'sub.country': 'Ülke',
  'sub.address': 'Adres',
  'sub.save': 'Kaydet',
  'sub.cancel': 'İptal',
  'sub.country.switzerland': 'İsviçre',
  'sub.country.germany': 'Almanya',
  'sub.country.austria': 'Avusturya',
  'sub.country.netherlands': 'Hollanda',
  'sub.country.belgium': 'Belçika',
  // Payment History
  'sub.paymentHistory': 'Ödeme Geçmişi',
  'sub.allInvoicesPDF': 'Logolu tüm faturaları PDF olarak indir',
  'sub.downloadAll': 'Tümünü indir',
  'sub.eurInvoiceNote': 'Faturalar her zaman CHF cinsinden düzenlenir. Görüntülenen EUR tutarları yalnızca referans içindir.',
  'sub.date': 'Tarih',
  'sub.description': 'Açıklama',
  'sub.net': 'Net',
  'sub.vat': 'KDV',
  'sub.total': 'Toplam',
  'sub.status': 'Durum',
  'sub.pdf': 'PDF',
  'sub.invoices': 'fatura',
  'sub.totalAmount': 'Toplam tutar',
  // Change Plan Modal
  'sub.changePlanTitle': 'Planı Değiştir',
  'sub.current': 'Mevcut',
  'sub.month': '/ay',
  'sub.showLess': 'Daha az göster',
  'sub.showMore': '+{{count}} daha fazla',
  'sub.switchPlan': 'Plana geç',
  'sub.eurPriceNote': 'Fiyatlar EUR ({{note}}) cinsinden gösterilir. Faturalama CHF cinsindendir.',
  // Cancel Modal
  'sub.cancelTitle': 'Abonelik gerçekten iptal edilsin mi?',
  'sub.cancelIrreversible': 'Bu işlem geri alınamaz.',
  'sub.cancelWarning1': 'Kalan tüm kredilerin süresi dolacak',
  'sub.cancelWarning2': 'Ücretsiz Plana Düşüş',
  'sub.cancelWarning3': 'Tüm premium özelliklerin kaybı',
  'sub.pauseInstead': 'Alternatif: Abonelik duraklatılsın mı?',
  'sub.pauseDesc': 'Verilerinizi saklamak için aboneliğinizi duraklatın.',
  'sub.preferPause': 'Duraklatmayı tercih et',
  'sub.cancelReason': 'İptal nedeni',
  'sub.selectReason': 'Lütfen seçin...',
  'sub.reason.tooExpensive': 'Çok pahalı',
  'sub.reason.notUsing': 'Yeterince kullanmıyorum',
  'sub.reason.missingFeatures': 'Eksik özellikler',
  'sub.reason.foundAlternative': 'Alternatif buldum',
  'sub.reason.other': 'Diğer',
  'sub.confirmType': 'Onaylama: "CANCEL" yazın *',
  'sub.cancelNow': 'Şimdi iptal et',
  // Add Card Modal
  'sub.addCardTitle': 'Yeni Kart Ekle',
  'sub.cardHolder': 'Kart Sahibi *',
  'sub.cardNumber': 'Kart Numarası *',
  'sub.expiryDate': 'Son Kullanma Tarihi *',
  'sub.addCard': 'Kart ekle',
  // Change Card Modal
  'sub.choosePayment': 'Ödeme yöntemini seçin',
  'sub.active': 'Aktif',
  'sub.close': 'Kapat',
  // Toast messages
  'sub.toast.cancelled': 'Aboneliğiniz fatura dönemi sonunda iptal edildi.',
  'sub.toast.reactivated': 'Aboneliğiniz başarıyla yeniden aktifleştirildi!',
  'sub.toast.planChanged': 'Plan başarıyla {{plan}} olarak değiştirildi!',
  'sub.toast.defaultChanged': 'Varsayılan ödeme yöntemi değiştirildi.',
  'sub.toast.cannotDeleteDefault': 'Varsayılan kart silinemez.',
  'sub.toast.cardRemoved': 'Kart kaldırıldı.',
  'sub.toast.fillAll': 'Lütfen tüm alanları doldurun.',
  'sub.toast.cardAdded': 'Yeni kart başarıyla eklendi!',
  'sub.toast.billingSaved': 'Fatura adresi kaydedildi.',
  'sub.toast.invoiceDownloaded': 'Fatura {{id}} indirildi!',
  'sub.toast.pdfError': 'PDF oluşturulurken hata oluştu.',
  // Chat interface
  'sub.notEnoughCredits': 'Yeterli kredi yok',
  'sub.needCredits': 'Soru başına en az {{count}} krediye ihtiyacınız var.',
  'sub.creditsLow': 'Krediler azalıyor',
  'sub.questionsLeft': '{{count}} soru mümkün.',
  'sub.plan': 'Plan',
  'sub.base': 'taban',
  'sub.unlimited': 'Sınırsız',
  'sub.status.active': 'Aktif',
  'sub.status.cancelled': 'İptal edildi',
  'sub.status.paused': 'Duraklatıldı',
  'sub.invoice': 'FATURA',
  'sub.from': 'GÖNDEREN',
  'sub.to': 'ALICI',
  'sub.vatId': 'KDV NO',
  'sub.tel': 'Tel',
  'sub.invoiceDate': 'Fatura tarihi',
  'sub.invoiceNumber': 'Fatura numarası',
  'sub.paymentStatus': 'Ödeme durumu',
  'sub.creditCard': 'Kredi kartı',
  'sub.quantity': 'ADET',
  'sub.price': 'FİYAT',
  'sub.amount': 'TUTAR',
  'sub.subtotal': 'Ara toplam',
  'sub.bank': 'Banka',
  'sub.card': 'Kart',
  'sub.cvc': 'CVC',
  'sub.cardHolderPlaceholder': 'John Doe',

  // ─── Admin Panel ─────────────────────────────────────────────────────────────
  'admin.title': 'Yönetici Paneli',
  'admin.subtitle': 'Kontrol Merkezi',
  'admin.superAdmin': 'Süper Yönetici',
  'admin.logout': 'Çıkış Yap',
  'admin.tabs.users': 'Kullanıcı Yönetimi',
  'admin.tabs.downgrades': 'Plan Düşüşleri',
  'admin.tabs.tips': 'Günün İpucu',
  'admin.tabs.coupons': 'Kupon Kodları',
  'admin.tabs.website': 'Web Sitesi Düzenleyici',
  'admin.tabs.ai': 'AI Ayarları',
  'admin.tabs.transactions': 'İşlem Günlüğü',
  'admin.tabs.stats': 'İstatistikler',
  'admin.users.searchPlaceholder': 'Kullanıcı ara (e-posta veya isim)...',
  'admin.users.manageSubscription': 'Aboneliği yönet',
  'admin.users.grantFree': 'Ücretsiz hesap ver',
  'admin.users.blockUser': 'Kullanıcıyı engelle',
  'admin.users.cancellationPlaceholder': 'Abonelik neden iptal ediliyor?',
  'admin.users.selectPlan': 'Plan seç',
  'admin.users.subChanged': '{{name}} aboneliği {{plan}} olarak değiştirildi',
  'admin.users.noReasonGiven': 'Sebep belirtilmedi',
  'admin.users.subCancelled': '{{name}} aboneliği iptal edildi ({{date}} tarihine kadar geçerli)',
  'admin.users.paused': 'Duraklatıldı',
  'admin.users.subPaused': '{{name}} aboneliği duraklatıldı',
  'admin.users.subReactivated': '{{name}} aboneliği yeniden aktifleştirildi',
  'admin.users.freeAccount': 'Ücretsiz Hesap',
  'admin.users.blocked': 'Engellendi',
  'admin.users.cancelledExpiring': 'İptal edildi (süresi doluyor)',
  'admin.users.cancelledOn': 'İptal edildi:',
  'admin.users.endsOn': 'Bitiş:',
  'admin.users.daysRemaining': 'gün kaldı',
  'admin.users.expired': '(Süresi doldu)',
  'admin.users.total': 'Toplam:',
  'admin.users.usersLabel': 'kullanıcı',
  'admin.users.free': 'ücretsiz',
  'admin.users.block': 'Engelle',
  'admin.users.unblock': 'Engeli kaldır',
  'admin.users.unblockUser': 'Kullanıcının engelini kaldır',
  'admin.users.selectAction': 'İşlem seç',
  'admin.users.cancelSub': 'Aboneliği iptal et',
  'admin.users.cancelSubDesc': 'Ay sonunda iptal',
  'admin.users.pauseSub': 'Aboneliği duraklat',
  'admin.users.pauseSubDesc': 'Geçici duraklatma',
  'admin.users.changePlan': 'Planı değiştir',
  'admin.users.changePlanDesc': 'Başka bir plana geç',
  'admin.users.reactivateSub': 'Aboneliği yeniden aktifleştir',
  'admin.users.reactivateDesc': 'İptali geri al',
  'admin.users.alreadyCancelled': 'Abonelik zaten iptal edildi',
  'admin.users.planLabel': 'Plan',
  'admin.users.cancellationReasonOpt': 'İptal nedeni (isteğe bağlı)',
  'admin.users.cancelInfo1': 'Abonelik şu tarihte sona erecek',
  'admin.users.cancelInfo2': '(ay sonu). O zamana kadar kullanıcının tam erişimi vardır. İade yok.',
  'admin.users.newPlan': 'Yeni plan',
  'admin.users.warning': 'Uyarı',
  'admin.users.blockDesc': 'Kullanıcı derhal oturumu kapatılacak ve tekrar giriş yapamayacaktır. Tüm aktif oturumlar sonlandırılacaktır.',
  'admin.users.confirmUnblock': 'Engel kaldırmayı onayla',
  'admin.users.unblockDesc': 'Kullanıcı tekrar giriş yapabilir ve tüm özellikleri kullanabilir.',
  'admin.users.afterBlock': 'Engellemeden sonra:',
  'admin.users.afterUnblock': 'Engel kaldırmadan sonra:',
  'admin.users.noAccountAccess': 'Hesap erişimi yok',
  'admin.users.noNewAnalyses': 'Yeni analiz yapılamaz',
  'admin.users.creditsStored': 'Krediler ve geçmiş saklanır',
  'admin.users.accessRestored': 'Hesap erişimi geri yüklendi',
  'admin.users.allFeaturesAvail': 'Tüm özellikler tekrar kullanılabilir',
  'admin.users.creditsPreserved': 'Krediler ve geçmiş korunur',
  'admin.users.downgrade': 'Plan Düşür',
  'admin.users.grantFreeBtn': 'Ücretsiz ver',
  'admin.users.durationMonths': 'Süre (ay)',
  'admin.users.months': 'ay',
  'admin.users.freePlan': 'ücretsiz',
  'admin.users.freeSummary': 'alır',
  'admin.users.withCredits': 'ile',
  'admin.users.credits': 'Kredi',
  'admin.users.subInfo': 'Abonelik Bilgileri',
  'admin.users.currentPlan': 'Mevcut Plan',
  'admin.users.joined': 'Katılım',
  'admin.users.totalSpent': 'Toplam Harcama',
  'admin.users.paymentMethod': 'Ödeme Yöntemi',
  'admin.users.validThrough': 'Geçerlilik',
  'admin.users.billingAddress': 'Fatura Adresi',
  'admin.users.transactionHistory': 'İşlem Geçmişi',
  'admin.users.cancellationDate': 'İptal tarihi',
  'admin.users.validUntil': 'Geçerlilik (ay sonu)',
  'admin.users.cancellationReason': 'İptal nedeni',
  'admin.users.noReason': 'Sebep belirtilmedi',
  'admin.users.timeRemaining': 'Kalan süre',
  'admin.users.daysUntilDeactivation': 'devre dışı bırakmaya gün kaldı',
  'admin.table.user': 'Kullanıcı',
  'admin.table.plan': 'Plan',
  'admin.table.subStatus': 'Abonelik Durumu',
  'admin.table.cancellation': 'İptal',
  'admin.table.payment': 'Ödeme Yöntemi',
  'admin.table.spending': 'Harcama',
  'admin.table.actions': 'İşlemler',
  'admin.actions.viewDetails': 'Detayları gör',
  'admin.actions.manageSubscription': 'Aboneliği yönet',
  'admin.actions.grantFree': 'Ücretsiz erişim ver',
  'admin.actions.block': 'Kullanıcıyı engelle',
  'admin.actions.unblock': 'Kullanıcının engelini kaldır',
  'admin.actions.cancel': 'İptal',
  'admin.actions.save': 'Kaydet',
  'admin.actions.delete': 'Sil',
  'admin.actions.confirm': 'Onayla',
  'admin.actions.done': 'Tamam',
  'admin.actions.edit': 'Düzenle',
  'admin.actions.close': 'Kapat',
  'admin.table.status': 'Durum',
  'admin.filter.all': 'Tümü',
  'admin.subscription.active': 'Aktif',
  'admin.subscription.cancelled': 'İptal edildi',
  'admin.subscription.paused': 'Duraklatıldı',
  'admin.subscription.unknown': 'Bilinmiyor',
  'admin.status.active': 'Aktif',
  'admin.status.inactive': 'Aktif değil',
  'admin.status.pending': 'Beklemede',
  'admin.status.approved': 'Onaylandı',
  'admin.status.rejected': 'Reddedildi',
  'admin.coupons.title': 'Kupon Yönetimi',
  'admin.coupons.subtitle': 'Kupon kodları oluşturun ve yönetin',
  'admin.coupons.newCoupon': 'Yeni Kupon',
  'admin.coupons.registrationCoupons': 'Kayıt Kuponları',
  'admin.coupons.trialCoupons': 'Deneme Erişim Kuponları',
  'admin.coupons.type': 'Tür',
  'admin.coupons.plan': 'Plan',
  'admin.coupons.value': 'Değer',
  'admin.coupons.usage': 'Kullanım',
  'admin.coupons.validUntil': 'Geçerlilik',
  'admin.coupons.created': 'Oluşturulma',
  'admin.coupons.actions': 'İşlemler',
  'admin.coupons.copyCode': 'Kodu kopyala',
  'admin.coupons.allPlans': 'Tüm Planlar',
  'admin.coupons.discount': 'İndirim',
  'admin.coupons.days': 'gün',
  'admin.coupons.months': 'ay',
  'admin.coupons.free': 'ücretsiz',
  'admin.coupons.unlimited': 'Sınırsız',
  'admin.coupons.createRegistration': 'Kayıt Kuponu Oluştur',
  'admin.coupons.createTrial': 'Deneme Erişim Kuponu Oluştur',
  'admin.coupons.couponCode': 'Kupon Kodu',
  'admin.coupons.codePlaceholder': 'örn. NF-7X3K9M',
  'admin.coupons.generateCode': 'Yeni kod oluştur',
  'admin.coupons.alertFillRequired': 'Lütfen tüm gerekli alanları doldurun',
  'admin.coupons.alertSelectExpiry': 'Lütfen bir son kullanma tarihi seçin veya "Sınırsız geçerlilik"i etkinleştirin',
  'admin.coupons.alertCreateError': 'Kupon oluşturulurken hata oluştu',
  'admin.coupons.confirmDelete': 'Bu kuporu silmek istediğinizden emin misiniz?',
  'admin.coupons.discountPercent': 'İndirim (%)',
  'admin.coupons.bonusCredits': 'Bonus Krediler',
  'admin.coupons.freeDuration': 'Ücretsiz Süre',
  'admin.coupons.maxUses': 'Maks. Kullanım',
  'admin.coupons.expiryDate': 'Son Kullanma Tarihi',
  'admin.coupons.unlimitedValidity': 'Sınırsız geçerlilik',
  'admin.coupons.unlimitedUses': 'Sınırsız kullanım',
  'admin.coupons.trialCredits': 'Deneme Kredileri',
  'admin.coupons.trialDuration': 'Deneme Süresi',
  'admin.coupons.typePlaceholder': 'örn. Erken Kuş, Partner, Influencer',
  'admin.coupons.duration': 'Süre',
  'admin.stats.totalUsers': 'Toplam Kullanıcı',
  'admin.stats.monthlyRevenue': 'Aylık Gelir',
  'admin.stats.activeSubscriptions': 'Aktif Abonelik',
  'admin.stats.average': 'Ortalama',
  'admin.stats.revenuePerUser': 'Kullanıcı Başına Gelir',
  'admin.stats.grossRevenue': 'Brüt Gelir',
  'admin.stats.net': 'NET',
  'admin.stats.netRevenue': 'Net Gelir',
  'admin.stats.churnRate': 'Ayrılma Oranı',
  'admin.stats.planDistribution': 'Plan Dağılımı',
  'admin.stats.users': 'kullanıcı',
  'admin.stats.revenueByPlan': 'Plana Göre Gelir',
  'admin.stats.recentActivity': 'Son Aktivite',
  'admin.stats.activity1': 'Thomas Weber Kurucu\'ya yükseltti',
  'admin.stats.activity2': 'Yeni kullanıcı kaydoldu',
  'admin.stats.activity3': 'Anna Schmidt Pro\'ya yükseltti',
  'admin.stats.hoursAgo2': '2 saat önce',
  'admin.stats.hoursAgo5': '5 saat önce',
  'admin.stats.dayAgo1': '1 gün önce',
  'admin.stats.couponStats': 'Kupon İstatistikleri',
  'admin.stats.totalRedemptions': 'Toplam Kullanım',
  'admin.stats.activeCoupons': 'Aktif Kuponlar',
  'admin.stats.registrationRedemptions': 'Kayıt Kullanımları',
  'admin.stats.trialRedemptions': 'Deneme Kullanımları',
  'admin.stats.couponDistribution': 'Kupon Dağılımı',
  'admin.stats.registrationCoupons': 'Kayıt Kuponları',
  'admin.stats.trialCoupons': 'Deneme Kuponları',
  'admin.stats.expiredInactive': 'Süresi Dolmuş/Aktif Değil',
  'admin.stats.topCoupons': 'En Çok Kullanılan Kuponlar',
  'admin.stats.redemptions': 'kullanım',
  'admin.stats.noCouponsRedeemed': 'Henüz kullanılmış kupon yok',
  'admin.downgrade.pending': 'beklemede',
  'admin.downgrade.refunds': 'İadeler',
  'admin.downgrade.sectionRequests': 'Talepler',
  'admin.downgrade.sectionStats': 'İstatistikler',
  'admin.downgrade.sectionRules': 'Kurallar',
  'admin.downgrade.pendingRequests': 'Bekleyen Talepler',
  'admin.downgrade.approvedRequests': 'Onaylanan Talepler',
  'admin.downgrade.rejectedRequests': 'Reddedilen Talepler',
  'admin.downgrade.activeRules': 'Aktif Kurallar',
  'admin.downgrade.autoRules': 'Otomatik Plan Düşürme Kuralları',
  'admin.downgrade.autoRulesDesc': 'Kullanım davranışına göre otomatik olarak plan düşüşünü tetikleyen kurallar oluşturun',
  'admin.downgrade.newRule': 'Yeni Kural',
  'admin.downgrade.totalRules': 'Toplam Kural',
  'admin.downgrade.triggeredActions': 'Tetiklenen İşlemler',
  'admin.downgrade.conditionsAnd': 'Koşullar (AND bağlı)',
  'admin.downgrade.action': 'İşlem',
  'admin.downgrade.successTitle': 'Plan düşürme başarılı!',
  'admin.downgrade.successDesc': 'Kullanıcının planı başarıyla düşürüldü ve iade işlemi yapıldı.',
  'admin.downgrade.closing': 'Kapatılıyor...',
  'admin.downgrade.title': 'Kullanıcı Planını Düşür',
  'admin.downgrade.currentPlan': 'Mevcut Plan',
  'admin.downgrade.spending': 'Harcama',
  'admin.downgrade.availablePlans': 'Plan Düşürme için Mevcut Planlar',
  'admin.downgrade.perMonth': 'aylık',
  'admin.downgrade.refundCalc': 'İade Hesaplaması',
  'admin.downgrade.currentPlanLabel': 'Mevcut Plan',
  'admin.downgrade.newPlan': 'Yeni Plan',
  'admin.downgrade.remainingDays': 'Kalan Günler',
  'admin.downgrade.daysOf': '30 günün 15\'i',
  'admin.downgrade.proRataRefund': 'Orantılı İade',
  'admin.downgrade.importantNote': 'Önemli Not',
  'admin.downgrade.warningDesc': 'Plan düşürme hemen uygulanacaktır. Kullanıcı premium özelliklere erişimini kaybedecek ve fazla krediler kaldırılacaktır.',
  'admin.downgrade.processing': 'İşleniyor...',
  'admin.downgrade.execute': 'Plan Düşürmeyi Uygula',
  'admin.downgrade.notification': 'Bildirim',
  'admin.downgrade.noNotification': 'Bildirim Yok',
  'admin.downgrade.daysPeriod': 'gün ek süre',
  'admin.downgrade.created': 'Oluşturulma:',
  'admin.downgrade.triggered': 'tetiklendi',
  'admin.downgrade.noRules': 'Henüz kural oluşturulmamış',
  'admin.downgrade.createFirstRule': 'İlk kuralı oluştur',
  'admin.downgrade.editRule': 'Kuralı Düzenle',
  'admin.downgrade.createRule': 'Yeni Kural Oluştur',
  'admin.downgrade.ruleName': 'Kural adı',
  'admin.downgrade.description': 'Açıklama',
  'admin.downgrade.allConditions': 'Koşullar (tümü karşılanmalı)',
  'admin.downgrade.addCondition': 'Koşul ekle',
  'admin.downgrade.type': 'Tür',
  'admin.downgrade.value': 'Değer',
  'admin.downgrade.fromPlan': 'Plan',
  'admin.downgrade.toPlan': 'Yeni plan',
  'admin.condition.inactivity': 'Hareketsizlik',
  'admin.condition.creditUsage': 'Kredi Kullanımı',
  'admin.condition.loginFrequency': 'Giriş Sıklığı',
  'admin.condition.featureUsage': 'Özellik Kullanımı',
  'admin.condition.supportTickets': 'Destek Talepleri',
  'admin.operator.lessThan': 'daha az',
  'admin.operator.greaterThan': 'daha fazla',
  'admin.operator.equals': 'tam olarak',
  'admin.operator.between': 'arasında',
  'admin.unit.days': 'gün',
  'admin.unit.perMonth': 'aylık',
  'admin.unit.count': 'adet',
  'admin.transactions.all': 'Tüm İşlemler',
  'admin.transactions.allCards': 'Tüm Kartlar',
  'admin.transactions.notFound': 'İşlem bulunamadı',
  'admin.transactions.totalLabel': 'Toplam',
  'admin.transactions.transactions': 'işlem',
  'admin.tips.title': 'Günün İpucu',
  'admin.tips.subtitle': 'Tüm kullanıcılara gösterilen ipuçlarını oluşturun ve yönetin',
  'admin.tips.active': 'Aktif',
  'admin.tips.currentlyShown': 'Bu ipucu şu anda tüm kullanıcılara gösteriliyor',
  'admin.tips.createNew': 'Yeni İpucu Oluştur',
  'admin.tips.generating': 'Oluşturuluyor...',
  'admin.tips.generateAI': 'AI İpucu Oluştur',
  'admin.tips.titleLabel': 'Başlık',
  'admin.tips.titlePlaceholder': 'örn. Günün İpucu',
  'admin.tips.category': 'Kategori',
  'admin.tips.categoryTip': 'İpucu',
  'admin.tips.categoryFeature': 'Yeni Özellik',
  'admin.tips.categoryProductivity': 'Verimlilik',
  'admin.tips.categoryUpdate': 'Güncelleme',
  'admin.tips.content': 'İçerik',
  'admin.tips.contentPlaceholder': 'İpucunuzu buraya yazın...',
  'admin.tips.addTip': 'İpucu Ekle',
  'admin.tips.allTips': 'Tüm İpuçları',
  'admin.tips.noTips': 'Henüz ipucu oluşturulmamış',
  'admin.tips.noTipsHint': 'Başlamak için "AI İpucu Oluştur"a tıklayın',
  'admin.noData': 'Veri mevcut değil',
  'admin.range.7d': '7 gün',
  'admin.range.30d': '30 gün',
  'admin.range.90d': '90 gün',
  'admin.range.1y': '1 yıl',
  'admin.actions.saveSettings': 'Ayarları kaydet',
  'admin.actions.create': 'Oluştur',
  'admin.downgrade.sectionReports': 'Raporlar',
  'admin.downgrade.settings': 'Plan Düşürme Ayarları',
  'admin.downgrade.autoApprove': 'Otomatik Onay',
  'admin.downgrade.autoApproveDesc': 'Plan düşürme taleplerini otomatik olarak onayla',
  'admin.downgrade.refundPolicy': 'İade Politikası',
  'admin.downgrade.prorata': 'Orantılı iade',
  'admin.downgrade.prorataDesc': 'Kalan günlere göre orantılı iade',
  'admin.downgrade.fullRefund': 'Tam iade',
  'admin.downgrade.fullRefundDesc': 'Fiyat farkının tam iadesi',
  'admin.downgrade.noRefund': 'İade yok',
  'admin.downgrade.noRefundDesc': 'İadesiz plan düşürme',
  'admin.downgrade.daysRemaining15': '(15 gün kala)',
  'admin.downgrade.requestsTitle': 'Plan Düşürme Talepleri',
  'admin.downgrade.approvalRate': 'Onay oranı',
  'admin.downgrade.mostCommonTransition': 'En yaygın geçiş',
  'admin.downgrade.mostCommonReason': 'En yaygın sebep',
  'admin.downgrade.avgProcessingTime': 'Ort. işlem süresi',
  'admin.downgrade.avgTimeDesc': 'Karara kadar geçen ortalama süre',
  'admin.downgrade.totalRefunds': 'Toplam İadeler',
  'admin.downgrade.pendingRefunds': 'Bekleyen İadeler',
  'admin.downgrade.summary': 'Özet',
  'admin.downgrade.total': 'Toplam',
  'admin.downgrade.csvDesc': 'Excel, Google Sheets için',
  'admin.downgrade.downloadCSV': 'CSV olarak indir',
  'admin.downgrade.jsonDesc': 'Geliştiriciler, API\'ler için',
  'admin.downgrade.downloadJSON': 'JSON olarak indir',
  'admin.downgrade.exportInfo': 'Dışa aktarma şunları içerir',
  'admin.downgrade.entries': 'seçilen dönemden girdi',
  'admin.downgrade.topReasons': 'En yaygın plan düşürme nedenleri',
  'admin.downgrade.refundHistory': 'İade Geçmişi',
  'admin.downgrade.noRefunds': 'Henüz iade yok',
  'admin.downgrade.statistics': 'Plan Düşürme İstatistikleri',
  'admin.downgrade.requests': 'Talepler',
  'admin.downgrade.monthlyTrend': 'Aylık Eğilim',
  'admin.downgrade.planTransitions': 'Plan Geçişleri',
  'admin.downgrade.trend': 'Eğilim (önceki aya göre)',
  'admin.downgrade.trendDesc': 'Daha az plan düşürme = daha iyi',
  'admin.coupons.allPlansUniversal': 'Tüm Planlar (Evrensel)',
  'admin.coupons.onlyStarter': 'Sadece Başlangıç',
  'admin.coupons.onlyPro': 'Sadece Pro',
  'admin.coupons.onlyBuilder': 'Sadece Kurucu',
  'admin.coupons.allPlansHint': 'Evrensel bir kupon için "Tüm Planlar"ı seçin',
  'admin.coupons.discountOptional': 'İndirim % (isteğe bağlı)',
  'admin.coupons.discountPlaceholder': 'örn. 50 için %50 indirim',
  'admin.coupons.bonusCreditsOptional': 'Bonus Krediler (isteğe bağlı)',
  'admin.coupons.bonusCreditsPlaceholder': 'örn. 500',
  'admin.coupons.freeDurationOptional': 'Ücretsiz Süre (isteğe bağlı)',
  'admin.coupons.durationPlaceholder': 'örn. 30',
  'admin.coupons.freeDurationHint': 'örn. 30 gün ücretsiz kullanım',
  'admin.coupons.noLimit': 'Kullanım sınırlaması yok',
  'admin.coupons.noExpiry': 'Son kullanma tarihi yok',
  'admin.coupons.creditsPlaceholder': 'örn. 100',
  'admin.coupons.creditsHint': 'Deneme erişimi için kredi sayısı',
  'admin.coupons.trialDurationHint': 'Deneme erişiminin geçerlilik süresi',
  'admin.coupons.autoCalculated': 'Deneme süresinden otomatik hesaplanır',
  'admin.websiteEditor.title': 'Web Sitesi Düzenleyici',
  'admin.websiteEditor.subtitle': 'Ana sayfanın tüm bölümlerini düzenleyin',
  'admin.websiteEditor.openPreview': 'Önizlemeyi Aç',
  'admin.websiteEditor.group.structure': 'Sayfa Yapısı',
  'admin.websiteEditor.group.design': 'Tasarım ve Düzen',
  'admin.websiteEditor.group.settings': 'Ayarlar',
  'admin.websiteEditor.tab.navbar': 'Navigasyon',
  'admin.websiteEditor.tab.howitworks': 'Nasıl Çalışır',
  'admin.websiteEditor.tab.about': 'Hakkımızda',
  'admin.websiteEditor.tab.pricing': 'Fiyatlandırma',
  'admin.websiteEditor.tab.sections': 'Bölümler',
  'admin.websiteEditor.tab.media': 'Medya',
  'admin.websiteEditor.tab.chatwidget': 'Bizimle Konuşun',
  'admin.websiteEditor.tab.invoice': 'Faturalar',
  'admin.websiteEditor.tab.legal': 'Yasal',
  'admin.websiteEditor.tab.seo': 'Temel SEO',
  'admin.websiteEditor.tab.advancedseo': 'Gelişmiş SEO',
  'admin.websiteEditor.tab.versions': 'Sürümler',
  'admin.hero.title': 'Hero Bölümünü Düzenle',
  'admin.hero.subtitle': 'Ana sayfanın metinleri, butonları ve istatistikleri',
  'admin.hero.reset': 'Sıfırla',
  'admin.hero.save': 'Kaydet',
  'admin.hero.savedMsg': 'Hero verileri kaydedildi!',
  'admin.hero.badge': 'Rozet Metni',
  'admin.hero.headings': 'Başlıklar',
  'admin.hero.line1White': 'Satır 1 (beyaz)',
  'admin.hero.line2Gold': 'Satır 2 (altın)',
  'admin.hero.subtitleSection': 'Alt Başlık',
  'admin.hero.line1': 'Satır 1',
  'admin.hero.line2': 'Satır 2',
  'admin.hero.buttons': 'Butonlar',
  'admin.hero.primaryBtn': 'Birincil Buton (altın)',
  'admin.hero.secondaryBtn': 'İkincil Buton (kenarlık)',
  'admin.hero.stats': 'İstatistikler',
  'admin.hero.statN': 'İstatistik {{n}}',
  'admin.hero.value': 'Değer',
  'admin.hero.label': 'Etiket',
  'admin.hero.previewNote': 'Değişiklikler kaydedildikten sonra ana sayfada görünür olacaktır. Önizlemeyi görmek için sayfayı yenileyin.',

  // Idea History
  'history.title': 'Fikir Geçmişi',
  'history.countLabel': '{{count}} analiz',
  'history.recentLabel': 'Son analizleriniz',
  'history.exportAll': 'Tümünü dışa aktar',
  'history.metrics.marketSize': 'Pazar Büyüklüğü',
  'history.metrics.competition': 'Rekabet',
  'history.metrics.startingCapital': 'Başlangıç Sermayesi',
  'history.metrics.timeToMarket': 'Pazara Çıkış Süresi',
  'history.metrics.profitPotential': 'Kar Potansiyeli',
  'history.metrics.scalability': 'Ölçeklenebilirlik',
  'history.summary.title': 'Özet',
  'history.download': 'İndir',
  'history.downloadJSON': 'JSON olarak kaydet',
  'history.downloadTXT': 'TXT olarak kaydet',
  'history.downloadPDF': 'PDF olarak kaydet',
  'history.fullAnalysis': 'Tam Analiz',
  'history.searchPlaceholder': 'Başlık veya etiketlere göre ara...',
  'history.filterAll': 'Tüm değerlendirmeler',
  'history.loading': 'Analizler yükleniyor...',
  'history.noResults': 'Sonuç bulunamadı',
  'history.empty': 'Henüz analiz yok',
  'history.emptyHint': 'AI Asistanında bir analiz başlatın',
  'history.delete': 'Sil',
  'history.cancel': 'İptal',
  'history.deleteModalTitle': 'Analiz silinsin mi?',
  'history.deleteModalDesc': '"{{title}}" kalıcı olarak silinecektir.',
  'history.errorLoading': 'Analizler yüklenirken hata oluştu',
  'history.deleteSuccess': 'Analiz başarıyla silindi',
  'history.deleteError': 'Analiz silinirken hata oluştu',
  'history.jsonExported': 'JSON dışa aktarıldı',
  'history.txtExported': 'TXT dışa aktarıldı',
  'history.allExported': '{{count}} fikir dışa aktarıldı',
  'history.analysisHeader': 'FİKİR ANALİZİ',
  'history.titleLabel': 'Başlık',
  'history.ratingLabel': 'Değerlendirme',
  'history.dateLabel': 'Tarih',
  'history.creditsLabel': 'Krediler',
  'history.analysisSection': 'Analiz',

  // Overview
  'overview.title': 'Genel Bakış',
  'overview.last24h': 'Son 24 saat',
  'overview.analysesToday': 'Bugünkü analizler',
  'overview.totalAnalyses': 'Toplam analiz',
  'overview.successRate': 'Başarı oranı',
  'overview.topRatings': 'En iyi değerlendirmeler',
  'overview.recentActivity': 'Son aktivite',
  'overview.viewAll': 'Tümünü gör',
  'overview.quickAccess': 'Hızlı erişim',
  'overview.quick.newAnalysis': 'Yeni analiz başlat',
  'overview.quick.newAnalysisDesc': 'Yeni bir AI destekli niş analizi başlatın',
  'overview.quick.myAnalyses': 'Analizlerim',
  'overview.quick.myAnalysesDesc': 'Tüm önceki analizleri görüntüleyin',
  'overview.quick.buyCredits': 'Kredi satın al',
  'overview.quick.buyCreditsDesc': 'Daha fazla analiz için daha fazla kredi',
  'overview.quick.settings': 'Ayarlar',
  'overview.quick.settingsDesc': 'Profili ve tercihleri özelleştirin',
  'overview.unlimitedCredits': 'Sınırsız kredi mevcut',
  'overview.creditsAvailable': 'kredi mevcut',
  'overview.upgradePlan': 'Planı yükselt',
  'overview.buyCredits': 'Kredi satın al',
  'overview.creditUsage': 'Bu ay kredi kullanımı',
  'overview.available': 'mevcut',

  // --- Admin New Keys ---
  'admin.transactions.upgrades': 'Yükseltmeler',
  'admin.transactions.downgrades': 'Plan Düşüşleri',
  'admin.transactions.visa': 'Visa',
  'admin.transactions.mastercard': 'Mastercard',
  'admin.transactions.amex': 'Amex',

  'admin.users.grantFreeSuccess': '{{name}} artık {{months}} ay ücretsiz {{plan}} planına sahip',
  'admin.users.blockSuccess': '{{name}} engellendi',
  'admin.users.unblockSuccess': '{{name}} engeli kaldırıldı',
  'admin.users.removeFreeSuccess': '{{name}} ücretsiz statüsü kaldırıldı',

  'admin.downgrade.plans.builder': 'Kurucu',
  'admin.downgrade.plans.pro': 'Pro',
  'admin.downgrade.plans.starter': 'Başlangıç',
  'admin.downgrade.plans.free': 'Ücretsiz',

  'admin.unit.percent': '%',

  'admin.tips.discoverNewFeature': 'Yeni Özelliği Keşfedin',
  'admin.tips.productivityBoost': 'Verimlilik Artışı',
  'admin.tips.importantUpdate': 'Önemli Güncelleme',
  'admin.tips.tipOfDay': 'Günün İpucu',

  'admin.actions.activate': 'Aktifleştir',
  'admin.actions.deactivate': 'Devre Dışı Bırak',
  'admin.websiteEditor.tab.features': 'Özellikler',
  'admin.websiteEditor.tab.testimonials': 'Referanslar',
  'admin.websiteEditor.tab.faq': 'SSS',
  'admin.websiteEditor.tab.cta': 'Harekete Geçirici Mesaj',
  'admin.websiteEditor.tab.footer': 'Alt Bilgi',
  'admin.websiteEditor.tab.design': 'Tasarım',
  'admin.websiteEditor.tab.customcode': 'Özel Kod',
  'admin.websiteEditor.tab.socials': 'Sosyal Medya',
  'admin.websiteEditor.tab.importexport': 'İçe/Dışa Aktar',

  // --- AI Settings Editor ---
  'admin.ai.title': 'AI Asistanı Ayarları',
  'admin.ai.subtitle': 'Davranış, stil ve analiz derinliğini yapılandırın',
  'admin.ai.smartWeightingActive': 'Akıllı Ağırlıklandırma Aktif',
  'admin.ai.smartWeightingDesc': 'AI, tüm perspektifleri akıllı ağırlıklandırma ile otomatik olarak birleştirir. Birden fazla ön ayar ile, ilk ön ayar daha yüksek ağırlığa sahiptir (birincil ön ayar). Ağırlıklandırmayı manuel olarak da ayarlayabilirsiniz.',
  'admin.ai.modelTitle': 'IdeaVerdict AI Modeli',
  'admin.ai.modelSubtitle': 'Tüm kullanıcı analizleri için AI motorunu seçin',
  'admin.ai.activeModel': 'Aktif model:',
  'admin.ai.activeModelDesc': 'Tüm kullanıcılar bu modelden yanıt alır.',
  'admin.ai.recommendations': 'En İyi Sonuçlar İçin Öneriler',
  'admin.ai.new': 'YENİ',
  'admin.ai.recommendationsDesc': 'En iyi analiz kalitesi için kanıtlanmış ön ayar kombinasyonları',
  'admin.ai.recommendationsInfo': 'Bu kombinasyonlar test edilmiştir ve en iyi sonuçları verir. Doğrudan uygulamak için bir öneriye tıklayın.',
  'admin.ai.active': 'AKTİF',
  'admin.ai.apply': 'Uygula',
  'admin.ai.avoid': 'Kaçının',
  'admin.ai.excellentQuality': 'Mükemmel Kalite',
  'admin.ai.goodQuality': 'İyi Kalite',
  'admin.ai.poorQuality': 'Seyreltilmiş Kalite - Önerilmez',
  'admin.ai.proTips': 'Pro İpuçları',
  'admin.ai.tip1Title': '2 ön ayar idealdir:',
  'admin.ai.tip1Desc': 'Seyreltme olmadan net perspektif',
  'admin.ai.tip2Title': 'Birincil ön ayar önemlidir:',
  'admin.ai.tip2Desc': 'İlk ön ayar en büyük etkiye sahiptir',
  'admin.ai.tip3Title': 'Zıtlardan kaçının:',
  'admin.ai.tip3Desc': '"AŞIRI" + "Yaratıcı" = çelişkili',
  'admin.ai.tip4Title': 'En fazla 3 ön ayar:',
  'admin.ai.tip4Desc': '4+ ön ayar ile sonuç çok genel olur',
  'admin.ai.warningManyPresets': 'Uyarı: Çok Fazla Ön Ayar',
  'admin.ai.warningManyPresetsDesc': '{{count}} ön ayar seçtiniz. Bu sonucu seyreltebilir.',
  'admin.ai.warningRecommend': 'Önerilen: En fazla 2-3 ön ayar',
  'admin.ai.forOptimalResults': 'en iyi sonuçlar için.',
  'admin.ai.presets': 'Ön Ayarlar',
  'admin.ai.multiSelect': '(çoklu seçim mümkün)',
  'admin.ai.presetsDesc': 'Bir veya daha fazla ön ayar seçin. İlk ön ayar, en yüksek ağırlığa sahip birincil ön ayardır.',
  'admin.ai.primaryPreset': 'Birincil Ön Ayar',
  'admin.ai.weightControl': 'Ağırlık Kontrolü',
  'admin.ai.weightControlDesc': 'Her ön ayarın analizi ne kadar güçlü etkilediğini ayarlayın',
  'admin.ai.manual': 'Manuel',
  'admin.ai.automatic': 'Otomatik',
  'admin.ai.autoWeightingActive': 'Otomatik ağırlıklandırma aktif:',
  'admin.ai.autoWeightingDesc': 'Ağırlıklandırma, ön ayar sayısına göre otomatik olarak optimize edilir.',
  'admin.ai.primary': 'BİRİNCİL',
  'admin.ai.totalWeight': 'Toplam',
  'admin.ai.shouldBe100': '100% olmalı',
  'admin.ai.normalize': 'Normalleştir',
  'admin.ai.combinedSettings': 'Birleştirilmiş Ayarlar',
  'admin.ai.presetsCount': 'ön ayar',
  'admin.ai.strictness': 'Katılık',
  'admin.ai.realism': 'Gerçekçilik',
  'admin.ai.creativity': 'Yaratıcılık',
  'admin.ai.detailLevel': 'Detay Seviyesi',
  'admin.ai.customInstructions': 'Özel Talimatlar',
  'admin.ai.customInstructionsDesc': 'Ön ayarlarla birleştirilen ek talimatlar',
  'admin.ai.customInstructionsPlaceholder': 'örn. "DACH pazarına odaklan", "Her zaman somut sayılar kullan", "Mevcut rakiplerle karşılaştır", "Her zaman örneklerle cevap ver"...',
  'admin.ai.customInstructionsHint': 'Bu talimatlar, seçilen ön ayarlarla otomatik olarak birleştirilir.',
  'admin.ai.manualFinetuning': 'Manuel İnce Ayar',
  'admin.ai.manualFinetuningHint': '(isteğe bağlı, ön ayar değerlerini geçersiz kılar)',
  'admin.ai.manualFinetuningDesc': 'Bir şeyi ince ayar yapmak istiyorsanız, birleştirilmiş değerleri manuel olarak ayarlayın.',
  'admin.ai.tone': 'Ton',
  'admin.ai.mild': 'Hafif',
  'admin.ai.strict': 'Katı',
  'admin.ai.creative': 'Yaratıcı',
  'admin.ai.realistic': 'Gerçekçi',
  'admin.ai.conservative': 'Muhafazakar',
  'admin.ai.compact': 'Kompakt',
  'admin.ai.detailed': 'Detaylı',
  'admin.ai.responseLength': 'Yanıt Uzunluğu',
  'admin.ai.short': 'Kısa ve Öz',
  'admin.ai.medium': 'Orta',
  'admin.ai.long': 'Detaylı',
  'admin.ai.focusAreas': 'Analiz Odak Alanları',
  'admin.ai.autoRating': 'Otomatik Değerlendirme',
  'admin.ai.autoRatingDesc': 'Her analiz otomatik olarak bir değerlendirme alır (İyi/Orta/Kötü)',
  'admin.ai.showSources': 'Kaynakları Göster',
  'admin.ai.showSourcesDesc': 'Yanıtlarda veri kaynaklarına ve pazar verilerine referanslar',
  'admin.ai.hidePreview': 'Önizlemeyi Gizle',
  'admin.ai.showPreview': 'Önizlemeyi Göster',
  'admin.ai.aiBehavior': 'AI Davranışı',
  'admin.ai.length': 'Uzunluk',
  'admin.ai.liveExample': 'Canlı Örnek',
  'admin.ai.testSettings': 'Ayarlarınızı test edin',
  'admin.ai.selectExampleQuestion': 'Örnek soru seçin:',
  'admin.ai.userAsks': 'Kullanıcı soruyor:',
  'admin.ai.generating': 'AI yanıt oluşturuyor...',
  'admin.ai.generateExample': 'Örnek Yanıt Oluştur',
  'admin.ai.aiResponds': 'AI Asistanı yanıtlıyor:',
  'admin.ai.generateHint': 'AI\'nın ayarlarınızla nasıl yanıt verdiğini görmek için "Örnek Yanıt Oluştur"a tıklayın.',
  'admin.ai.reset': 'Sıfırla',
  'admin.ai.saved': 'Kaydedildi!',
  'admin.ai.saveSettings': 'Ayarları Kaydet',

  // --- Table headers ---
  'admin.coupons.code': 'Kod',
  'admin.coupons.credits': 'Krediler',

  // --- AI Model Descriptions ---
  'admin.ai.model.standardDesc': 'Yüksek kaliteli dengeli analiz. Çoğu niş değerlendirmesi ve fikir doğrulaması için en iyi seçim.',
  'admin.ai.model.preciseAnalyses': 'Hassas Analizler',
  'admin.ai.model.bestBalance': 'En İyi Denge',
  'admin.ai.model.recommended': 'Önerilen',
  'admin.ai.model.fastDesc': 'Hızlı niş kontrolleri, beyin fırtınası ve ilk değerlendirmeler için yıldırım hızında yanıtlar. Hız önemli olduğunda ideal.',
  'admin.ai.model.fast': 'HIZLI',
  'admin.ai.model.fastestResponses': 'En Hızlı Yanıtlar',
  'admin.ai.model.thinkingDesc': 'Gelişmiş mantıksal düşünme ile derin analiz. Karmaşık pazar analizleri, eleştirel değerlendirmeler ve stratejik planlama için.',
  'admin.ai.model.deepestAnalysis': 'En Derin Analiz',
  'admin.ai.model.logicalThinking': 'Mantıksal Düşünme',
  'admin.ai.model.strategy': 'Strateji',

  // --- AI Preset Names & Descriptions ---
  'admin.ai.preset.strict.name': 'Katı Analiz',
  'admin.ai.preset.strict.desc': 'Eleştirel, gerçeklere dayalı, şekerleme yok. Zayıflıkları acımasızca ortaya çıkarır.',
  'admin.ai.preset.extreme.name': 'AŞIRI Analiz',
  'admin.ai.preset.extreme.desc': 'Maksimum katılık, acımasız eleştiri, en kötü senaryo odaklı. Sadece sert gerçeklik kontrolleri için.',
  'admin.ai.preset.professional.name': 'Profesyonel',
  'admin.ai.preset.professional.desc': 'Objektif, yapılandırılmış, dengeli. Deneyimli bir iş danışmanı gibi.',
  'admin.ai.preset.realistic.name': 'Gerçekçi',
  'admin.ai.preset.realistic.desc': 'Dürüst ve pratik. Uygulanabilir uygulama ve gerçek pazar verilerine odaklanır.',
  'admin.ai.preset.creative.name': 'Yaratıcı ve Motive Edici',
  'admin.ai.preset.creative.desc': 'İlham verici, fikir zengini, pozitif. Fırsatları ve alışılmadık yolları bulur.',
  'admin.ai.preset.balanced.name': 'Dengeli',
  'admin.ai.preset.balanced.desc': 'Eleştiri ve motivasyonun iyi karışımı. Varsayılan mod.',
  'admin.ai.preset.investor.name': 'Yatırımcı Perspektifi',
  'admin.ai.preset.investor.desc': 'Bir Girişim Kapitalisti gibi. Ölçeklendirme, ROI ve çıkış stratejisine odaklanır.',
  'admin.ai.preset.startup-coach.name': 'Startup Koçu',
  'admin.ai.preset.startup-coach.desc': 'Kurucular için pratik mentor. Hızlı uygulama ve MVP\'ye odaklanır.',
  'admin.ai.preset.market-researcher.name': 'Pazar Araştırmacısı',
  'admin.ai.preset.market-researcher.desc': 'Veri odaklı ve analitik. Derin pazar ve rekabet analizi.',
  'admin.ai.preset.risk-analyst.name': 'Risk Analisti',
  'admin.ai.preset.risk-analyst.desc': 'Riskler ve en kötü senaryolara odaklanır. Gerçekçi planlama için.',

  // --- Focus Areas ---
  'admin.ai.focus.marktanalyse': 'Pazar Analizi',
  'admin.ai.focus.wettbewerb': 'Rekabet',
  'admin.ai.focus.monetarisierung': 'Paraya Çevirme',
  'admin.ai.focus.risiken': 'Riskler',
  'admin.ai.focus.finanzen': 'Finans',
  'admin.ai.focus.skalierung': 'Ölçeklendirme',
  'admin.ai.focus.innovation': 'İnovasyon',
  'admin.ai.focus.trends': 'Trendler',
  'admin.ai.focus.differenzierung': 'Farklılaşma',
  'admin.ai.focus.umsetzung': 'Uygulama',
  'admin.ai.focus.zielgruppe': 'Hedef Kitle',
  'admin.ai.focus.marketing': 'Pazarlama',

  // --- Tone Options ---
  'admin.ai.tone.direkt': 'Doğrudan ve Sert',
  'admin.ai.tone.professionell': 'Profesyonel ve Objektif',
  'admin.ai.tone.ehrlich': 'Dürüst ve Pratik',
  'admin.ai.tone.motivierend': 'Motive Edici ve Pozitif',
  'admin.ai.tone.freundlich': 'Dostça ve Destekleyici',
  'admin.ai.tone.akademisch': 'Akademik ve Analitik',

  // --- Example Questions ---
  'admin.ai.question.niche': 'Hangi karlı nişi önerirsiniz?',
  'admin.ai.question.evaluate': 'Fikrimi değerlendir: Köpek sahipleri için bir uygulama',
  'admin.ai.question.trends': 'Şu anda hangi trendlerin potansiyeli var?',
  'admin.ai.question.sharpen': 'Nişimi nasıl keskinleştirebilirim?',

  'admin.ai.rec.bestCombination.title': '🏆 En İyi Kombinasyon (2 Ön Ayar)',
  'admin.ai.rec.bestCombination.desc': 'Eleştirel ama yapıcı, somut eylem adımlarıyla',
  'admin.ai.rec.bestCombination.useCase': 'Çoğu analiz için önerilir',

  'admin.ai.rec.balancedThree.title': '⚖️ Dengeli (3 Ön Ayar)',
  'admin.ai.rec.balancedThree.desc': 'Profesyonel, gerçekçi ve yatırımcı dostu',
  'admin.ai.rec.balancedThree.useCase': 'Kapsamlı iş analizleri için',

  'admin.ai.rec.creativeDriven.title': '💡 Yaratıcı ve Motive Edici (2 Ön Ayar)',
  'admin.ai.rec.creativeDriven.desc': 'Pratik uygulama ipuçlarıyla ilham verici',
  'admin.ai.rec.creativeDriven.useCase': 'Fikir üretme ve beyin fırtınası için',

  'pdf.rating.good': 'Good',
  'pdf.rating.bad': 'Bad',
  'pdf.rating.medium': 'Medium',
  'pdf.header.subtitle': 'Analysis View',
  'pdf.footer.tagline': 'AI-Powered Niche Validation',
  'pdf.footer.page': 'Page',
  'pdf.benchmark.title': 'INDUSTRY BENCHMARK',
  'pdf.benchmark.yourScore': 'Your Score',
  'pdf.benchmark.top10': 'Top 10%: 85+',
  'pdf.marketAnalysis.title': 'MARKET ANALYSIS',
  'pdf.summary.title': 'SUMMARY',
  'pdf.structuredSummary.verdict': 'VERDICT',
  'pdf.disclaimer.body': 'This report was generated by an AI model and is intended for informational purposes only. It does not constitute financial, legal, tax, or investment advice. Market data, ratings, and projections are AI-generated estimates and may be incomplete or inaccurate. Please verify all information independently and consult qualified professionals before making any business or investment decisions. IdeaVerdict assumes no liability for actions taken based on this report.',
  'pdf.disclaimer.title': 'IMPORTANT NOTICE',
  'pdf.closing.title': 'Generated by IdeaVerdict',
  'pdf.closing.subtitle': 'AI-Powered Niche Validation  |  Comprehensive Market Intelligence',
  'history.swot.title': 'SWOT Analysis',
  'history.swot.strengths': 'Strengths',
  'history.swot.weaknesses': 'Weaknesses',
  'history.swot.opportunities': 'Opportunities',
  'history.swot.risks': 'Risks',
  'history.sections.recommendations': 'Recommendations',
  'history.sections.marketAnalysis': 'Competitive Analysis',
  'history.sections.microAngles': 'Micro-Niche Angles',
  'history.sections.improvements': 'Improvement Suggestions',
  'history.sections.alternatives': 'Alternative Niches',
  'history.sections.structuredSummary': 'Structured Summary (Builder)',
  'history.structuredSummary.strengths': 'Top Strengths',
  'history.structuredSummary.risks': 'Top Risks',
  'history.structuredSummary.actions': 'Next Steps',
  'history.sections.developerBriefing': 'Developer Briefing (Builder)',
  'history.sections.conversation': 'Conversation History',
  'history.conversation.user': 'User',
  'history.conversation.assistant': 'IdeaVerdict',
  'history.conversation.structuredResult': 'Structured Result',
  'admin.tabs.usage': 'Usage',
  'admin.usage.title': 'AI Usage & Cost Analysis',
  'admin.usage.refresh': 'Refresh data',
  'admin.usage.requests': 'Requests',
  'admin.usage.users': 'Users',
  'admin.usage.totalTokens': 'Total Tokens',
  'admin.usage.apiCosts': 'API Costs',
  'admin.usage.revenue': 'Revenue',
  'admin.usage.margin': 'Margin',
  'admin.usage.byModel': 'By Model',
  'admin.usage.allModels': 'All Models',
  'admin.usage.searchEmail': 'Search by email address...',
  'admin.usage.perPage': 'Per page:',
  'admin.usage.loading': 'Loading usage data...',
  'admin.usage.noEntries': 'No entries found for current filters.',
  'admin.usage.time': 'Time',
  'admin.usage.user': 'User',
  'admin.usage.model': 'Model',
  'admin.usage.credits': 'Credits',
  'admin.usage.tokens': 'Tokens',
  'admin.usage.duration': 'Duration',
  'admin.usage.details': 'Details',
  'admin.usage.showing': 'Showing',
  'admin.usage.of': 'of',
  'admin.usage.entries': 'entries',
  'admin.usage.firstPage': 'First Page',
  'admin.usage.prevPage': 'Previous',
  'admin.usage.page': 'Page',
  'admin.usage.nextPage': 'Next',
  'admin.usage.lastPage': 'Last Page',
  'admin.usage.requestDetails': 'Request Details',
  'admin.usage.close': 'Close',
  'admin.usage.loadingDetails': 'Loading details...',
  'admin.usage.inputTokens': 'Input Tokens',
  'admin.usage.outputTokens': 'Output Tokens',
  'admin.usage.providerCost': 'Provider Cost',
  'admin.usage.providerBreakdown': 'Provider Breakdown',
  'admin.usage.fullResponseData': 'Full Response Data',
  'admin.usage.entryNotFound': 'This entry could not be loaded.',
  'admin.usage.today': 'Today',
  'admin.usage.last7d': 'Last 7 Days',
  'admin.usage.last30d': 'Last 30 Days',
  'admin.usage.allTime': 'All Time',
  'admin.ai.fallbackModel': 'Fallback Model',
  'admin.ai.systemPrompts': 'System Prompts',
  'admin.ai.fallbackModelDesc': 'Used when the primary model fails or returns invalid output',
  'admin.ai.systemPromptsDesc': 'Read-only view of what each model receives as instructions',
  'admin.ai.provider': 'Provider',
  'admin.ai.modelId': 'Model ID',
  'admin.ai.maxTokens': 'Max Tokens',
  'admin.ai.temperature': 'Temperature',
  'admin.ai.thinkingBudget': 'Thinking Budget',
  'admin.ai.supportsThinking': 'Supports Thinking',
  'admin.ai.displayName': 'Display Name',
  'admin.ai.precise': 'Precise',
  'admin.ai.creativeTemp': 'Creative',

  // Header + Sidebar (auto-added by rebrand)
  'header.openMenu': 'Menüyü aç',
  'header.home': 'Ana sayfa',
  'header.notifications': 'Bildirimler',
  'header.settings': 'Ayarlar',
  'header.profile': 'Profil',
  'sidebar.collapse': 'Kenar çubuğunu daralt',
  'sidebar.expand': 'Kenar çubuğunu genişlet',
  'sidebar.close': 'Menüyü kapat',
  'sidebar.plan': 'Plan',
  'sidebar.backToWebsite': 'Siteye dön',

  // Legal — Imprint (auto-added)
  'legal.imprint.title': 'Imprint',
  'legal.imprint.company': 'Scherbius Technology',
  'legal.imprint.location': 'Dubai, United Arab Emirates (UAE)',
  'legal.imprint.seatLabel': 'Registered office',
  'legal.imprint.seatBody': 'Dubai, United Arab Emirates',
  'legal.imprint.contactLabel': 'Contact',
  'legal.imprint.contactBody': 'Contact details are provided at the sole discretion of Scherbius Technology.',
  'legal.imprint.representationLabel': 'Legal representation',
  'legal.imprint.representationBody': 'Scherbius Technology is represented by its legal representatives in accordance with the laws of the United Arab Emirates.',
  'legal.imprint.contentLiabilityLabel': 'Liability for content',
  'legal.imprint.contentLiabilityBody': 'The contents of this website have been created with the greatest possible care.\nHowever, Scherbius Technology assumes no liability for the accuracy, completeness or timeliness of the content.',
  'legal.imprint.linksLiabilityLabel': 'Liability for external links',
  'legal.imprint.linksLiabilityBody': 'This website may contain links to external third-party websites whose content we have no control over.\nNo liability is assumed for these external contents.',
  'legal.imprint.lawLabel': 'Applicable law',
  'legal.imprint.lawBody': 'The laws of the United Arab Emirates apply exclusively.\nPlace of jurisdiction is Dubai, UAE.',

  // Overview page (auto-added)
  'overview.greeting': 'Tekrar hoş geldin',
  'overview.greetingSub': 'Karar masanda neler oluyor.',
  'overview.heroCta': 'Yeni karar',
  'overview.currentPlan': 'Mevcut paket',
  'overview.creditsLabel': 'kredi',
  'overview.usedThisCycle': 'Bu döngüde kullanılan',
  'overview.resetsOn': 'Sıfırlanma',
  'overview.unlimitedTitle': 'Sınırsız',
  'overview.builderPerk': 'Tam Builder erişimin var — limit yok.',
  'overview.runOne': 'Karar al',
  'overview.lastVerdicts': 'Son 5 kararın',
  'overview.noActivity': 'Henüz karar yok — ilk analizini başlat',
  'overview.tipTitle': 'İpucu',
  'overview.tipBody': 'Bir fikri iki dilde test et — eğer karar yumuşuyorsa, varsayımların yerel, evrensel değil.',
  'onboard.skip': "Atla",
  'onboard.cta.next': "İleri",
  'onboard.cta.start': "Başla",
  'onboard.s1.title': "IdeaVerdict'e hoş geldiniz",
  'onboard.s1.body': "Daha kurmadan, iş fikrinize bir yapay zeka kararı.",
  'onboard.s2.title': "Acımasız dürüst kararlar",
  'onboard.s2.body': "Hype yok, dalkavukluk yok. Gerçek pazar verisi, gerçek rakipler, gerçek riskler.",
  'onboard.s3.title': "PDF olarak Builder Raporları",
  'onboard.s3.body': "Tam mimari, finans ve pazara giriş stratejisiyle 25-75 sayfalık raporlar oluşturun.",
  'onboard.s4.title': "Siz hazır olduğunuzda hazır",
  'onboard.s4.body': "Kaydolun ve ilk kararınızı bir dakikadan kısa sürede alın.",
  'builderReport.title': "Builder Raporunuz hazırlanıyor",
  'builderReport.subtitle': "Kapsamlı analiz + geliştirici brifingi — hazır olunca PDF olarak iner.",
  'builderReport.idea': "Fikriniz",
  'builderReport.ideaPlaceholder': "İş fikrinizi tarif edin (ya da son konuştuğumuz fikri kullanmak için boş bırakın)…",
  'builderReport.cta': "Rapor Oluştur",
  'builderReport.credits': "kredi",
  'builderReport.deductedNow': "Başarı durumunda düşülür",
  'builderReport.dontClose': "Lütfen bu pencereyi kapatmayın — oluşturma 30-90 saniye sürebilir.",
  'builderReport.done': "PDF indirildi — indirilenler klasörünüzü kontrol edin.",
  'builderReport.failed': "Oluşturma başarısız",
  'builderReport.close': "Kapat",
  'builderReport.cancel': "İptal",
  'builderReport.running': "Oluşturuluyor…",
  'builderReport.retry': "Tekrar dene",
  'builderReport.unknownError': "Oluşturma başarısız. Krediler iade edilmiş olmalı.",
  'builderReport.signInRequired': "Rapor oluşturmak için giriş yapmalısınız.",
  'builderReport.ideaRequired': "Yapay zekanın analiz edebilmesi için fikrinizi tarif edin.",
  'builderReport.fromChat': "Mevcut sohbetinizden",
  'builderReport.noIdeaDetected': "Konuştuğumuz fikri kullanıyoruz.",
  'builderReport.contextHint': "Yapay zeka bu sohbetteki her şeyi kullanacak — yeni bir fikir uydurulmayacak.",
  'builderReport.step.core': "Temel analiz oluşturuluyor",
  'builderReport.step.market': "Genişletilmiş pazar analizi ekleniyor",
  'builderReport.step.tech': "Teknik mimari ekleniyor",
  'builderReport.step.financials': "Finansal modeller ekleniyor",
  'builderReport.step.compet': "Rekabet istihbaratı ekleniyor",
  'builderReport.step.gtm': "Pazara giriş stratejisi ekleniyor",
  'builderReport.step.deepdive': "Sektör derinlemesine analizi ekleniyor",
  'builderReport.step.pdf': "PDF derleniyor…",
  'briefing.title': "Developer Briefing hazırlanıyor",
  'briefing.subtitle': "11 bölümlük teknik brifing — hazır olunca PDF olarak iner.",
  'briefing.ideaPlaceholder': "İş fikrinizi tarif edin (ya da son konuştuğumuz fikri kullanmak için boş bırakın)…",
  'briefing.cta': "Brifing Oluştur",
  'briefing.step.core': "Geliştirici brifingi oluşturuluyor",
  'briefing.step.pdf': "PDF derleniyor…",
  'pricing.gold.name': "Gold",
  'pricing.gold.description': "Daha fazla kredi + 50 sayfalık raporlar",
  'pricing.gold.credits': "Ayda 12.500 Kredi",
  'pricing.platinum.name': "Platinum",
  'pricing.platinum.description': "Maksimum seviye + 75 sayfalık raporlar",
  'pricing.platinum.credits': "Ayda 15.000 Kredi",
  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "tr" yet. Replace with native translations as needed.
  'nav.slogan': 'An AI verdict on your business idea — before you build',
  'chat.creditsPerQuestion': 'Credits/question',
  'chat.notEnoughCreditsTitle': 'Not enough credits',
  'chat.notEnoughCreditsDesc': 'You need at least {{cost}} credits per question.',
  'chat.creditsRunningLow': 'Credits running low',
  'chat.questionsRemaining': '{{count}} questions remaining.',
  'chat.noCreditsModalTitle': 'Not enough credits',
  'chat.noCreditsModalDesc': 'You need at least <1>{{cost}} credits</1> per question. Your current balance: <2>{{balance}} credits</2>',
  'chat.currentPlan': 'Current plan',
  'chat.close': 'Close',
  'chat.upgrade': 'Upgrade',
  'sub.manageBilling': 'Manage billing',
  'credits.topup.buyMore': 'Buy more credits',
  'trial.creditsLow': "Sadece {{count}} Kredi kaldı!",
  'trial.upgradeNow': "Şimdi yükselt",
  'trial.upgradeNowArrow': "Şimdi yükselt →",
  'trial.creditsExhausted': "Krediler tükendi",
  'trial.upgradeForUnlimited': "Sınırsız kullanım için yükseltin",
  'trial.noCreditsPlaceholder': "Kredi kalmadı…",
  'hero.badgeHonest': "Dürüst, tarafsız yapay zeka",
  'hero.badge60sec': "60 saniyede karar",
  'hero.badge20Lang': "20+ dil",
  'hero.widget.label': "Fikir Kararı",
  'hero.widget.passed': "GEÇTİ",
  'hero.widget.demoIdea': "Tıp öğrencileri için yapay zeka eğitmeni",
  'hero.widget.market': "Pazar",
  'hero.widget.demand': "Talep",
  'hero.widget.competition': "Rekabet",
  'hero.widget.verdictReady': "Karar hazır · 47 sn",
  'hero.widget.riskFlagged': "Risk işaretlendi",
  'hero.widget.crowdedMarket': "Kalabalık pazar · 4 yerleşik oyuncu",
  'hero.widget.suggestedPivot': "Önerilen pivot",
  'hero.widget.nicheBySpecialty': "Uzmanlığa göre niş",
  'hero.widget.feasibilityGain': "+%38 uygulanabilirlik",
  'hero.widget.analysisDone': "Analiz tamamlandı",
  'hero.widget.metrics56': "6 metrikten 5'i",
  'hero.stats.verdictSpeed': "Karar hızı",
  'cta.badge': "60 saniyede karar",
  'cta.subtitleEnd': "tahmin yürütmeden.",
  'cta.signinPrompt': "Zaten hesabınız var mı? Giriş yapın",
  'cta.trustTrial': "7 günlük ücretsiz deneme",
  'cta.trustNoCard': "Kart gerekmez",
  'cta.trustCancel': "İstediğin zaman iptal",
  'footer.themeLabel': "Tema:",
  'footer.lightMode': "Açık Mod",
  'footer.darkMode': "Koyu Mod",
  'footer.sectionProduct': "Ürün",
  'footer.sectionLegal': "Yasal",
  'nav.switchLight': "Açık Moda geç",
  'nav.switchDark': "Koyu Moda geç",
  'features.badge': "Neden IdeaVerdict",
  'features.mainFeatureLabel': "Başlık",
  'chatError.planRestriction': "Bu özellik daha yüksek bir plan gerektirir.",
  'chatError.creditDeduction': "Ödeme işlemi başarısız. Lütfen tekrar deneyin.",
  'chatError.aiService': "AI servisi geçici olarak kullanılamıyor. Kredilerin düşülmedi. Lütfen tekrar deneyin.",
  'chatError.parseError': "Beklenmedik yanıt biçimi alındı. Lütfen tekrar deneyin.",
  'chatError.sessionExpired': "Oturumun sona erdi. Lütfen tekrar giriş yap.",
  'chatError.timeout': "İstek çok uzun sürdü. Lütfen tekrar deneyin.",
  'chatError.generic': "Yanıt alınamadı. Lütfen tekrar deneyin.",

  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "tr" yet. Replace with native translations as needed.
  'faq.badge': "FAQ",
  'trial.lowCredits': "Sadece {{count}} Kredi kaldı!",
  'trial.outOfCredits': "Krediler tükendi",
  'trial.outOfCreditsDesc': "Upgrade to keep getting verdicts.",
  'trial.viewPlans': "View plans",
  'trial.tryDemo': "Try the demo",
  'hero.widget.crowded': "Kalabalık pazar · 4 yerleşik oyuncu",
  'hero.widget.nicheBySpec': "Uzmanlığa göre niş",
  'hero.widget.feasibilityUp': "+%38 uygulanabilirlik",
  'hero.widget.fiveOfSix': "6 metrikten 5'i",
  'builderReport.modalTitle': "Builder Report",
  'builderReport.modalSubtitle': "Generate a comprehensive PDF for your idea",
  'builderReport.formatLabel': "Report format",
  'builderReport.formatStandard': "Standard report",
  'builderReport.formatExec': "Executive summary",
  'builderReport.toneLabel': "Tone",
  'builderReport.toneProfessional': "Professional",
  'builderReport.toneCasual': "Casual",
  'builderReport.toneTechnical': "Technical",
  'builderReport.sectionsLabel': "Sections to include",
  'builderReport.sectionMarket': "Market analysis",
  'builderReport.sectionCompetition': "Competitive landscape",
  'builderReport.sectionFinancial': "Financial model",
  'builderReport.sectionArchitecture': "Technical architecture",
  'builderReport.sectionGTM': "Go-to-market plan",
  'builderReport.sectionRisks': "Risk register",
  'builderReport.sectionRoadmap': "Product roadmap",
  'builderReport.sectionTeam': "Team & hiring plan",
  'builderReport.actionGenerate': "Generate report",
  'builderReport.actionCancel': "Cancel",
  'builderReport.actionDownload': "Download PDF",
  'builderReport.statusGenerating': "Generating your report…",
  'builderReport.statusComplete': "Report ready",
  'builderReport.statusError': "Something went wrong. Try again.",
  'builderReport.creditsRequired': "This will use {credits} credits.",
  'builderReport.pageCount': "{pages} pages",
  'builderReport.tip1': "Tip: be specific about your target customer for sharper analysis.",
  'builderReport.tip2': "Tip: include early revenue numbers if you have them.",
  'builderReport.tip3': "Tip: mention your tech preferences if any.",
  'builderReport.errorNotEnough': "You don't have enough credits for this report.",
  'builderReport.errorUpgrade': "Upgrade to a higher plan",
  'builderReport.errorTryStandard': "Try the Standard report instead",
  'builderReport.success': "Your Builder Report is ready.",
  'builderReport.previewBadge': "Preview",
  'builderReport.previewNote': "This is a preview. Generate the full PDF to see all sections.",
  'builderReport.includesLabel': "Includes",
  'builderReport.pagesIncluded': "{pages} pages of analysis",
  'builderReport.estimatedTime': "Estimated time: {minutes} min",
  'builderReport.fullReport': "Full report",
  'builderReport.execSummary': "Executive summary",
  'pricing.builder.report': "25 sayfa Builder Report",
  'pricing.gold.report': "50 sayfa Builder Report",
  'pricing.platinum.report': "75 sayfa Builder Report",
  'auth.bestValue': "En İyi Değer",
  'auth.elite': "Elit",
  'builderReport.friendlyError': "Bu sefer raporunuzu tamamlayamadık. Kredileriniz düşülmedi — lütfen biraz sonra tekrar deneyin.",
  'builderReport.persistHint': "Bu sorun devam ederse support@ideaverdict.ai ile iletişime geçin.",
};
